
<template>
    <div class="flex flex-wrap md:flex-nowrap gap-1 font-sans items-start">
  
      <!-- LEFT SIDE -->
      <div class="w-full md:w-2/3">
        <div class="flex flex-col space-y-3 bg-white rounded-lg shadow-lg p-4">
  
          <!-- search -->
          <input
            v-model="searchTerm"
            type="text"
            placeholder="Search..."
            class="w-60 px-2 py-1 border border-gray-300 rounded-md text-sm shadow-sm
                   focus:border-[#add8e6] focus:outline-none focus:ring-1 focus:ring-[#add8e6]"
          />
  
          <!-- departments -->
    
  
  <!-- Added outline-none to remove the focus border -->
  <div class="flex w-full overflow-x-auto outline-none" style="scrollbar-width:none; -ms-overflow-style:none;" tabindex="-1">
    <div
      v-for="(dept,index) in departments"
      :key="dept.id"
      @click="selectDept(dept)"
      :class="[
        'flex-1 min-w-fit px-4 text-sm whitespace-nowrap cursor-pointer h-9 flex items-center justify-center flex-shrink-0',
        /* Keep existing border logic */
        index === 0 ? 'rounded-l-sm' : '',
        index === departments.length - 1 ? 'rounded-r-sm' : '',
        selectedDept && selectedDept.id === dept.id
          ? 'bg-green-700 text-white border-none shadow-none text-bold'
          : 'text-gray-800 hover:bg-gray-100 border border-gray-300'
      ]"
    >
      {{ dept.name }}
    </div>
  </div>
  
  
  
  
          <!-- sub departments -->
          <div 
            v-if="selectedDept && selectedDept.subDepartments && selectedDept.subDepartments.length" 
            class="flex overflow-x-auto" 
            style="scrollbar-width:none; -ms-overflow-style:none;" 
            tabindex="-1"
          >
            <div
              v-for="(sub,index) in selectedDept.subDepartments"
              :key="sub.id"
              @click="selectSub(sub)"
              :class="[
                'px-2 text-xs whitespace-nowrap capitalize cursor-pointer h-8 min-h-8 flex items-center justify-center flex-shrink-0 border border-[#0d4169]',
                index === 0 ? 'rounded-l-sm' : '',
                index === selectedDept.subDepartments.length - 1 ? 'rounded-r-sm' : '',
                selectedSub && selectedSub.id === sub.id
                  ? ' text-[0d4169] border-green-700 border-1px text-[#0d4169] font-bold'
                  : 'text-[#0d4169] font-bold hover:bg-gray-100 border border-gray-300'
              ]"
              :style="{ minWidth: '60px' }"
            >
              {{ sub.name }}
            </div>
          </div>
  
          <!-- menus grid -->
          <div class="">
            <div class="grid gap-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-3">
            <div
    v-for="menu in filteredMenus"
    :key="menu.id || menu._id || menu.code"
    @click="((menu.isAvailable ?? menu.is_available ?? 1) === 1) ? addToBill(menu) : null"
    class="cursor-pointer border rounded-lg p-2 flex flex-col justify-between bg-white shadow-lg hover:shadow-xl transition-all duration-150 active:bg-[#1a5a8a] active:text-white"
    :class="{ 
      'cursor-not-allowed grayscale-[0.5]': (menu.isAvailable ?? menu.is_available ?? 1) === 0 
    }"
  >
    <div>
      <h4 
        class="text-base font-semibold transition-colors duration-150"
        :class="{ 'text-red-600': (menu.isAvailable ?? menu.is_available ?? 1) === 0 }"
      >
        {{ menu.name }}
      </h4>
  
      <p 
        class="text-sm text-gray-600 mt-1 transition-colors duration-150"
        :class="{ 'text-red-400': (menu.isAvailable ?? menu.is_available ?? 1) === 0 }"
      >
        {{ ((Number(menu.totalPrice ?? menu.total_price) || 0).toFixed(2)) }}
      </p>
    </div>
  </div>
  
              <div
                v-if="filteredMenus.length === 0"
                class="col-span-full text-center py-10 font-bold"
                style="color: #0d4169;"
              >
               <div class="text-2xl">Wellcome Back,</div>
               <div class="text-lg opacity-80 mt-2">Have you a nice day!</div>
               <div 
                 class="text-sm mt-4 font-medium"
                 :class="departments.length === 0 ? 'text-red-600' : 'opacity-60'"
               >
                 {{ departments.length === 0 ? 'No department to select' : 'Select department to continue' }}
               </div>
              </div>
            </div>
          </div>
  
        </div>
      </div>
  
      <!-- RIGHT SIDE -->
      <div class="w-full md:w-1/3  ">
        <div class="flex flex-col bg-white rounded-lg shadow-lg border-l border-gray-200">
  
          <!-- action buttons above bill -->
         <div class="flex flex-col p-4 pt-1 pr-1 pl-2 pb-2 border-b border-gray-100 overflow-hidden bg-gray-50/50">
         <div class="flex items-center justify-between flex-nowrap gap-1">
    
    <!-- LEFT SIDE -->
    <div class="flex items-center space-x-1 overflow-hidden">
      
      <div class="relative inline-flex items-start mr-3" v-if="1==3">
        <button 
          @click="() => { clearBillAreaOnly(); showTransferModal = true; }"
          class="px-2 py-1 text-sm border border-gray-300 rounded-sm hover:bg-gray-100 bg-white shadow-sm font-semibold text-gray-700"
        >
          Transfer
        </button>
  
        <span 
          v-if="transferBadgeCount > 0"
          class="absolute top-1.5 left-2 -translate-y-1/2 -translate-x-1/2 bg-red-600 text-white text-[9px] w-4 h-3 px-1 rounded-full flex items-center justify-center font-bold shadow z-50"
        >
          {{ transferBadgeCount }}
        </span>
      </div>
  
      <button 
        @click="handleOrdersButtonClick" 
        :disabled="!canViewAllOrders"
        :class="['px-2 py-1 text-[12px] border rounded-sm flex-shrink-0 font-semibold shadow-sm transition-all', viewMode === 'orders' && !ordersScheduleFilterDate ? 'bg-blue-600 text-white border-blue-600' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-100', !canViewAllOrders ? 'opacity-50 cursor-not-allowed hover:bg-white' : '']"
        :title="!canViewAllOrders ? 'You do not have View privileges for Special Orders' : ''"
      >
        {{ ordersButtonLabel }}
      </button>
      <input
        v-if="!selectedOrderDate"
        v-model="ordersScheduleFilterDate"
        type="date"
        title="Filter by schedule date"
        :disabled="!canViewAllOrders"
        @change="handleOrdersScheduleDateChange"
        :class="['px-1 py-1 text-[12px] border rounded-sm flex-shrink-0 font-semibold shadow-sm transition-all max-w-[138px]', viewMode === 'orders' && ordersScheduleFilterDate ? 'bg-blue-600 text-white border-blue-600' : 'bg-white border-gray-300 text-gray-700', !canViewAllOrders ? 'opacity-50 cursor-not-allowed' : 'hover:bg-gray-100']"
      />
    </div>
  
    <!-- RIGHT SIDE: Date + Open Price -->
    <div class="flex items-center space-x-1 flex-shrink-0">
      <span 
        v-if="selectedOrderDate" 
        class="text-[10px] font-black text-[#0d4169] bg-white px-1 py-1 whitespace-nowrap"
      >
        {{ selectedOrderDate }}
      </span>
      <button
        @click="activateOpenPriceMode"
        :class="['px-2 py-1 text-[12px] border rounded-sm flex-shrink-0 font-semibold shadow-sm transition-all', isOpenPriceMode ? 'bg-blue-600 text-white border-blue-600' : 'bg-white border-gray-300 text-gray-700 hover:bg-gray-100']"
      >
        Open Price
      </button>
    </div>
  
  </div>
  </div>
  
          <hr>
       <!-- Changed items-center to items-stretch and added flex to children -->
          <!-- NEW HEADER LAYOUT -->
        
  
  <div class="bg-[#db490b] pb-2">
  
    <!-- TOP GRID: LEFT + RIGHT -->
    <div class="grid grid-cols-[minmax(108px,_auto)_1fr] py-2 border-b border-gray-100 px-2">
      
      <!-- LEFT -->
      <div class="text-left flex flex-col space-y-1 h-full pr-2 ">
        <div class="flex flex-col">
          <div v-if="tableError && !isDelivery" class="text-[10px] font-bold text-white mt-0.5 animate-bounce">
            Select Table Number
          </div>
  
          <div class="text-white text-[15px] font-bold tracking-tight whitespace-nowrap">
            Table &nbsp;
            <span class="font-bold">
              {{ String(tableNumber).length <=5 ? tableNumber || '---' : '---' }}
            </span>
  
            <button 
              v-if="tableNumber" 
              @click="tableNumber = ''" 
              :disabled="!!currentEditingOrderId"
              :class="currentEditingOrderId ? 'opacity-50 cursor-not-allowed' : 'hover:text-red-700'"
              class="text-white text-sm ml-1"
            >
              ×
            </button>
          </div>
        </div>
  
        <hr>
  
        <div class="flex flex-col text-white">
          <div class="text-[12px] font-bold capitalize leading-tight">Waiter</div>
          <div class="text-[15px] font-bold capitalize tracking-tight whitespace-nowrap">
            {{ selectedWaiter.split(" ")[0] }}
          </div>
        </div>
      </div>
  
      <!-- RIGHT -->
      <div class="flex flex-col space-y-1 pl-2 border-l border-gray-100 w-full">
        <!-- Row 1 -->
        <div class="flex w-full space-x-1">
          <button 
            v-for="n in [1, 2, 3, 4, 5]" 
            :key="n"
            @click="appendTableNumber(n)"
            :disabled="!!currentEditingOrderId || viewMode === 'orders'"
            class="active:bg-[#1a5a8a] active:text-white flex-1 h-8 flex items-center justify-center border border-gray-200 text-[16px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
            :class="!!currentEditingOrderId || viewMode === 'orders' ? 'opacity-50 cursor-not-allowed hover:bg-gray-50 active:translate-y-0' : ''"
          >
            {{ n }}
          </button>
        </div>
  
        <!-- Row 2 -->
        <div class="flex w-full space-x-1">
          <button 
            v-for="n in [6, 7, 8, 9, 0]" 
            :key="n"
            @click="appendTableNumber(n)"
            :disabled="!!currentEditingOrderId || viewMode === 'orders'"
            class="active:bg-[#1a5a8a] active:text-white flex-1 h-8 flex items-center justify-center border border-gray-200 text-[16px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
            :class="!!currentEditingOrderId || viewMode === 'orders' ? 'opacity-50 cursor-not-allowed hover:bg-gray-50 active:translate-y-0' : ''"
          >
            {{ n }}
          </button>
        </div>
      </div>
  
    </div> <!-- end of grid -->
  
    <!-- FULL-WIDTH ROW BELOW GRID for Special Order -->
    <div class="w-full mt-1 px-2">
      <span class="block text-[14px] font-black text-[#0d4169] bg-white px-1 py-0 w-full text-center capitalize flex items-center justify-center">
        Special Order
      </span>
    </div>
  
  </div>
  
          <hr>
          <div ref="billContainer" class="p-4 pr-1 pl-1 flex-1 overflow-y-auto">          <!-- CURRENT BILL VIEW -->
            <template v-if="viewMode === 'bill'">
              <div >
                 <!-- Print Failure Alert -->
                 <div v-if="printFailures.length > 0" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 font-bold animate-pulse text-center shadow-sm">
                   <div class="text-sm">⚠️ Printing Failed</div>
                   <div v-for="dept in printFailures" :key="dept" class="text-[11px] mt-1">{{ dept }}</div>
                   <div class="text-[10px] mt-1 text-green-600">But the Order was saved.</div>
                 </div>
  
                 <!-- bill header titles -->
              <div v-if="!isOpenPriceMode" class="flex items-center mb-2 space-x-2 font-semibold text-sm">
                <span v-if="!currentEditingOrderId" class="w-4 text-center"></span>
                <span v-if="currentEditingOrderId" class="w-11 text-left">Qty</span>
                <span v-else class="w-4 pl-2 text-center">Qty</span>
                
  
                <span class="flex-1">Name</span>
                <span v-if="currentEditingOrderId" class="text-left text-[9px] leading-tight pr-2">U.P</span>
                <span v-if="currentEditingOrderId" class="text-left text-[9px] leading-tight pr-1">T.P</span>
                
                <div class="flex items-left space-x-1 pl-1">
                  <button 
                    v-if="billItems.length > 0 && currentEditingOrderId && canVoidOrder" 
                    @click="clearBill()"
                    class="flex text-red-600 items-center border border-gray-200 justify-left px-0.5 h-4 rounded-sm hover:bg-gray-100 transition-colors duration-200"
                    title="Void Entire Order"
                  >
                    <span class="text-[12px]">Void</span>
                  </button>
                  <!-- Transfer select-all checkbox disabled for special orders
                  <input 
                    v-if="billItems.length > 0 && currentEditingOrderId"
                    type="checkbox"
                    @change="e => billItems.forEach(i => i.selected = e.target.checked)"
                    class="w-3 h-4 rounded border-gray-100 text-blue-600 focus:ring-blue-500 transition-all cursor-pointer"
                    title="Select All for Transfer"
                    :disabled="!isOwnOrder && !isAdmin"
                    :class="(!isOwnOrder && !isAdmin) ? 'opacity-50 cursor-not-allowed grayscale' : ''"
                  />
                  -->
                </div>
              </div>
  
              <!-- bill items -->
              <template v-if="!isOpenPriceMode">
              <div
                v-for="item in sortedBillItems"
                :key="item.itemId || item.transferredItemId || item.localId"
                class="flex flex-col mb-2 border rounded-sm relative"
                :class="item.transferredQty > 0
                  ? 'bg-green-100/70 border-green-300'
                  : item.itemId && (item.ownNotPrintedCount || 0) > 0
                    ? 'bg-gray-50/20 border-blue-50/50'
                    : 'bg-gray-50/20 border-blue-50/50'"
              >
                <span 
                  v-if="(item.itemId || item.transferredItemId) && ((item.transferredNotPrintedCount || 0) + (item.ownNotPrintedCount || 0)) > 0" 
                  class="absolute -top-1.5 -left-1.4 z-10 bg-red-500 text-white text-[8px] w-3 h-3 flex items-center justify-center rounded-full font-bold shadow-sm"
                  title="Quantity failed to print"
                >
                  {{ (item.transferredNotPrintedCount || 0) + (item.ownNotPrintedCount || 0) }}
                </span>
                <div class="flex items-center p-1 px-0 space-x-2">
                  <button v-if="!item.itemId && !item.transferredItemId" @click="changeQty(item, item.qty + 1)" class="text-green-600 text-sm px-1">+</button>
                  <input
                    type="number"
                    v-model.number="item.qty"
                    :readonly="!!item.itemId || !!item.transferredItemId"
                    @change="changeQty(item, item.qty)"
                    class="w-7 text-center text-sm border rounded focus:outline-none focus:border-[#add8e6] no-spinner"
                    :class="(item.itemId || item.transferredItemId) ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''"
                  />
                  <button 
                    @click="changeQty(item, item.qty - 1)" 
                    :disabled="!canVoidOrder && (item.itemId || item.transferredItemId)"
                    :class="['text-red-600 text-sm px-1', (!canVoidOrder && (item.itemId || item.transferredItemId)) ? 'opacity-50 cursor-not-allowed' : '']"
                  >–</button>
                  <div class="flex-1 min-w-0 pr-1 cursor-pointer relative group flex flex-col justify-center" @click="toggleExpansion(item)">
                    <span 
                      class="text-[13px] truncate leading-tight"
                      :class="{ 'text-red-600 font-bold': (item.itemId || item.transferredItemId) &&((item.ownNotPrintedCount || 0) > 0 || (item.transferredNotPrintedCount || 0) > 0)}"
                    >
                      {{ item.menu?.name || item.itemName || 'Item' }}
                    </span>
                    <button
                      v-if="item.isOpenPrice && canVoidOrder"
                      type="button"
                      @click.stop="removeFromBill(item)"
                      class="absolute right-0 top-1/2 -translate-y-1/2 text-red-500 text-sm px-1 hover:bg-red-50 rounded"
                      title="Remove open-price item"
                    >×</button>
                    <p v-if="item.itemId || item.transferredItemId" class="text-[9px] text-blue-500 absolute left-0 transform transition-transform duration-200" :class="[item.isExpanded ? 'rotate-180' : '', (!item.notPrintedCount || item.notPrintedCount === 0) ? 'bottom-0' : '-bottom-3']">▼</p>
                  </div>
                  
                  <div v-if="item.itemId || item.transferredItemId" class="w-6 text-right text-[9px] text-gray-500 self-center font-medium">
                    {{ Number(item.menu.totalPrice || 0).toFixed(1) }}
                  </div>
                  <div v-if="item.itemId || item.transferredItemId" class="w-6 text-right text-[9px] font-bold text-gray-700 self-center pr-1">
                    {{ (item.qty * Number(item.menu.totalPrice || 0)).toFixed(1) }}
                  </div>
  
                  <div class="flex items-center space-x-1 pl-1">
                    <!-- Expansion button for NEW items only on the right side -->
                    <button 
                      v-if="!item.itemId && !item.transferredItemId"
                      @click="toggleExpansion(item)"
                      class="p-1 text-blue-500 hover:bg-blue-50 rounded transition-colors"
                    >
                      <span class="text-[10px] transform transition-transform duration-200 block" :class="item.isExpanded ? 'rotate-180' : ''">▼</span>
                    </button>
  
                    <button 
                      v-if="!item.isOpenPrice && (canVoidOrder || !item.orderId)"
                      @click="removeFromBill(item)" 
                      :disabled="!canVoidOrder && !!item.orderId"
                      :class="['text-red-500 text-sm px-1', (!canVoidOrder && !!item.orderId) ? 'opacity-50 cursor-not-allowed' : '']"
                      title="Remove Item"
                    >×</button>
                    
                    <!-- Transfer item checkbox disabled for special orders
                    <input 
                      v-if="item.orderId"
                      type="checkbox"
                      v-model="item.selected"
                      class="w-3 h-4 rounded border-gray-100 text-blue-600 focus:ring-blue-500 transition-all cursor-pointer mx-1"
                      :disabled="!isOwnOrder && !isAdmin"
                      :class="(!isOwnOrder && !isAdmin) ? 'opacity-50 cursor-not-allowed grayscale' : ''"
                    />
                    -->
                  </div>
                </div>
  
                <!-- Ingredients Expansion Panel -->
                <Transition
                  enter-active-class="transition duration-100 ease-out"
                  enter-from-class="max-h-0 opacity-0"
                  enter-to-class="max-h-60 opacity-100"
                  leave-active-class="transition duration-75 ease-in"
                  leave-from-class="max-h-60 opacity-100"
                  leave-to-class="max-h-0 opacity-0"
                >
                  <div v-if="item.isExpanded" class="p-3 bg-white border-t border-gray-50 overflow-hidden">
                    <div class="text-[14px] text-gray-800 capitalize tracking-wider mb-2">Note</div>
                    <input
                      v-model="item.note"
                      type="text"
                      :readonly="!!item.itemId || !!item.transferredItemId"
                      placeholder="Write note here..."
                      class="w-full mb-3 px-3 py-1.5 border border-gray-200 rounded text-sm outline-none focus:border-blue-400 focus:ring-1 focus:ring-blue-100 transition-all"
                     :class="(item.itemId || item.transferredItemId) ? 'bg-gray-50 text-gray-500 cursor-not-allowed' : ''"
                    />
                    
                    <div v-if="item.ingredients && item.ingredients.length">
                      <div class="text-[14px] text-gray-800 capitalize tracking-wider mb-2">Customize Ingredients</div>
                    <div class="grid grid-cols-1 gap-2">
    <div
      v-for="ing in item.ingredients"
      :key="ing.id"
      class="flex items-center space-x-2 p-1.5 hover:bg-gray-50 rounded transition-colors group"
      :class="(item.itemId || item.transferredItemId) ? 'opacity-70' : ''"
    >
      <input 
        type="checkbox" 
        v-model="ing.checked" 
        :disabled="!!item.itemId || !!item.transferredItemId"
        class="w-3.5 h-3.5 rounded text-blue-600 focus:ring-blue-500 border-gray-300 transition-all"
        :class="(item.itemId || item.transferredItemId) ? 'cursor-not-allowed bg-gray-100' : 'cursor-pointer'"
      />
      <span 
        class="text-xs text-gray-600 group-hover:text-gray-900 transition-colors truncate"
        :class="!ing.checked ? 'line-through text-gray-400' : ''"
      >
        {{ ing.name }}
      </span>
    </div>
  </div>
                    </div>
                  </div>
                </Transition>
              </div>
  
              <div v-if="billItems.length === 0" class="text-gray-500 text-sm italic py-4">
                No items added.
              </div>
  
              <div class="mt-4 mb-4 text-right">
                <!-- Waiter Transfer UI -->
                <div v-if="billItems.some(i => i.selected && i.orderId)" class="mb-4 p-2 bg-blue-50 rounded-sm border border-blue-100 animate-in slide-in-from-bottom-2">
                  <div class="flex space-x-1">
                    <select 
                      v-model="selectedWaiterId"
                      class="flex-1 text-xs border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none bg-white"
                    >
                      <option value="" disabled>Select Waiter</option>
                      <option v-for="user in waiters" :key="user.id" :value="user.id">
                        {{ user.full_name || user.username }}
                      </option>
                    </select>
                    <button 
                      @click="transferSelectedItems"
                      class="px-3 py-1 bg-blue-600 text-white rounded-sm text-xs font-bold hover:bg-blue-700 transition-colors shadow-sm"
                    >
                      Transfer
                    </button>
                  </div>
                </div>
  
                <div class="pt-2 pr-2 border-t border-gray-100 text-right space-y-0.5 text-[11px]">
                  <div>
                    <span class="text-gray-600">Base Amt:</span>
                    <span class="font-semibold text-gray-700 ml-1">{{ billAmountSummary.baseAmt }} </span>
                  </div>
                  <div>
                    <span class="text-gray-600">Additional Amt:</span>
                    <span class="font-semibold text-gray-700 ml-1">{{ billAmountSummary.additionalAmt }} </span>
                  </div>
                  <div>
                    <span class="text-gray-600">TAX Amt:</span>
                    <span class="font-semibold text-gray-700 ml-1">{{ billAmountSummary.taxAmt }} </span>
                  </div>
                  <div class="pt-0.5">
                    <span class="font-semibold text-gray-700">Grand Total: {{ billAmountSummary.grandTotal }} </span>
                  </div>
                </div>
              </div>
              </template>

              <div class="mt-4 mb-4 text-right">
                <div class="pt-2 pr-2 text-left space-y-1.5 text-[11px]">
                  <div v-if="isOpenPriceMode" class="space-y-1.5 pb-1">
                    <div class="relative">
                      <input
                        v-model="openPriceItemName"
                        type="text"
                        placeholder="Item Name"
                        class="w-full text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                        :class="canVoidOrder && billItems.length ? 'pr-8' : ''"
                      />
                      <button
                        v-if="canVoidOrder && billItems.length"
                        type="button"
                        @click="removeFromBill(billItems[0])"
                        class="absolute right-1 top-1/2 -translate-y-1/2 text-red-500 text-sm px-1 hover:bg-red-50 rounded"
                        title="Remove open-price item"
                      >Void</button>
                    </div>
                    <div class="flex space-x-1">
                      <input
                        v-model.number="openPriceUnitPrice"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="Unit Price"
                        class="flex-1 min-w-0 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                      />
                      <input
                        v-model.number="openPriceQty"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="Quantity"
                        class="flex-1 min-w-0 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                      />
                    
                    </div>
                  </div>
                  <div class="flex space-x-1">
                    <input
                      v-model="specialOrderName"
                      type="text"
                      placeholder="Name"
                      class="flex-1 min-w-0 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                    />
                    <input
                      v-model="specialOrderPhone"
                      type="text"
                      placeholder="Phone"
                      class="flex-1 min-w-0 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                    />
                  </div>
                  <div class="flex space-x-1">
                    <input
                      v-model="specialOrderScheduleDate"
                      type="date"
                      title="Schedule date"
                      class="flex-1 min-w-0 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                    />
                    <select
                      v-model="specialOrderPaymentType"
                      @change="handleSpecialOrderPaymentTypeChange"
                      class="flex-1 min-w-0 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none bg-white"
                    >
                      <option value="">Payment Type</option>
                      <option v-for="m in availablePaymentMethods" :key="m.id" :value="m.name">
                        {{ m.name }}
                      </option>
                    </select>
                  </div>
                  <div class="flex space-x-1">
                    <div
                      v-if="showSpecialOrderRefNumber"
                      class="relative flex-1 min-w-0"
                    >
                      <input
                        v-model="specialOrderRefNumber"
                        type="text"
                        placeholder="Ref Number"
                        class="w-full text-sm border border-gray-300 rounded-sm py-1 pl-2 focus:ring-1 focus:ring-blue-500 outline-none"
                        :class="showSpecialOrderRefScan ? 'pr-9' : 'pr-2'"
                      />
                      <button
                        v-if="showSpecialOrderRefScan"
                        type="button"
                        @click="openTxnScanPicker"
                        :disabled="isScanningTransaction"
                        class="absolute right-1 top-1/2 -translate-y-1/2 w-7 h-7 flex items-center justify-center rounded text-[#0d4169] hover:bg-[#0d4169]/10 active:scale-95 transition-all disabled:opacity-50"
                        title="Scan transaction ID from screenshot or camera"
                      >
                        <svg v-if="!isScanningTransaction" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <rect x="3" y="3" width="7" height="7"></rect>
                          <rect x="14" y="3" width="7" height="7"></rect>
                          <rect x="3" y="14" width="7" height="7"></rect>
                          <path d="M14 14h.01"></path>
                          <path d="M20 14h.01"></path>
                          <path d="M14 20h.01"></path>
                          <path d="M20 20h.01"></path>
                          <path d="M17 17h.01"></path>
                          <path d="M17 20h.01"></path>
                          <path d="M20 17h.01"></path>
                        </svg>
                        <span v-else class="txn-scan-spinner"></span>
                      </button>
                    </div>
                    <input
                      v-model="specialOrderAdvancePayment"
                      type="number"
                      min="0"
                      step="0.01"
                      placeholder="Advance payment"
                      class="flex-1 min-w-0 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                    />
                  </div>
                  <div v-if="specialOrderPaidSoFar > 0" class="pt-0.5 text-right text-gray-500">
                    <span>Paid so far:</span>
                    <span class="font-semibold ml-1">{{ specialOrderPaidSoFar.toFixed(2) }} </span>
                  </div>
                  <div class="pt-0.5 text-right flex flex-wrap items-center justify-end gap-x-3 gap-y-0.5">
                    <span
                      v-if="scannedReceiverDisplay"
                      class="text-[11px] font-semibold text-slate-600 leading-snug whitespace-pre-line text-left"
                    >
                      {{ scannedReceiverDisplay }}
                    </span>
                    <span>
                      <span class="text-gray-600">Remaining:</span>
                      <span
                        class="font-semibold ml-1"
                        :class="Number(specialOrderRemaining) < 0 ? 'text-red-600' : 'text-gray-700'"
                      >{{ specialOrderRemaining }} </span>
                    </span>
                  </div>
                  <div
                    class="mt-1 border-2 border-dashed border-gray-300 rounded-sm p-2 bg-gray-50/60"
                  >
                    <div class="flex items-center justify-between gap-2 mb-1">
                      <span class="text-gray-600 font-semibold">Item Image (optional)</span>
                      <div class="flex space-x-1">
                        <label class="px-2 py-0.5 text-[10px] bg-white border border-gray-300 rounded-sm cursor-pointer hover:bg-gray-100">
                          Upload
                          <input type="file" accept="image/*" class="hidden" @change="onSpecialOrderImageSelect" />
                        </label>
                        <label class="px-2 py-0.5 text-[10px] bg-white border border-gray-300 rounded-sm cursor-pointer hover:bg-gray-100">
                          Capture
                          <input type="file" accept="image/*" capture="environment" class="hidden" @change="onSpecialOrderImageSelect" />
                        </label>
                        <button
                          v-if="specialOrderItemImage"
                          type="button"
                          @click="clearSpecialOrderImage"
                          class="px-2 py-0.5 text-[10px] bg-red-50 text-red-600 border border-red-200 rounded-sm hover:bg-red-100"
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                    <div v-if="specialOrderItemImageUrl" class="mt-1">
                      <img
                        :src="specialOrderItemImageUrl"
                        alt="Item"
                        class="max-h-24 w-full object-contain rounded-sm border border-gray-200 bg-white"
                      />
                    </div>
                    <div v-else class="text-[10px] text-gray-400 italic py-3 text-center">
                      Upload or capture an image
                    </div>
                  </div>
                  <div class="flex flex-col items-start w-full pt-1">
                    <label class="pl-1 text-[11px] font-bold text-slate-500 capitalize tracking-wider mb-1.5">
                      Remark (optional)
                    </label>
                    <textarea
                      v-model="specialOrderRemark"
                      rows="2"
                      placeholder="Add remark..."
                      class="w-full px-3 py-1.5 bg-gray-50 border border-gray-200 rounded text-left text-sm focus:bg-white focus:border-[#0d4169] outline-none transition-all resize-none"
                    />
                  </div>
                </div>
              </div>
  
              <!-- action buttons below total -->
              <div class="flex pr-2 pl-2 flex-col space-y-2">
                <!-- First Row: Clear, Delivery, Send -->
                <div class="flex space-x-1">
                  <button 
                    @click="handleBackOrClear" 
                    class="flex-1 px-2 py-1 text-sm bg-red-500 text-white rounded-sm hover:bg-red-600"
                  >
                    {{ currentEditingOrderId ? 'Back' : 'Clear' }}
                  </button>
                  <!-- <button 
                    @click="isDelivery = !isDelivery" 
                    :class="[
                      'flex-1 px-2 py-1 text-sm border rounded-sm transition-colors',
                      isDelivery ? 'bg-orange-600 text-white border-orange-600' : 'bg-orange-700 text-white border-orange-500 hover:bg-orange-600'
                    ]"
                  >
                    Delivery
                  </button> -->
                  <button 
                    @click="sendOrder" 
                    :disabled="isSending || Number(specialOrderRemaining) < 0 || (currentEditingOrderId ? !canEditOrder : !canAddOrder)"
                    class="flex-1 px-2 py-1 text-sm bg-blue-600 text-white rounded-sm hover:bg-blue-600 disabled:bg-blue-400 disabled:cursor-not-allowed flex items-center justify-center min-h-[32px]"
                    :title="currentEditingOrderId ? (!canEditOrder ? 'You do not have Edit privileges for Special Orders' : '') : (!canAddOrder ? 'You do not have Add privileges for Special Orders' : '')"
                  >
                    <span v-if="isSending" class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    <span v-else>{{ currentEditingOrderId ? 'Update' : 'Send' }}</span>
                  </button>
                </div>

                <!-- Confirm: same save/validate as Send/Update, marks is_paid=1 only when remaining is 0 -->
                <div v-if="canConfirmOrder" class="w-full pt-1">
                  <button
                    @click="confirmOrder"
                    :disabled="isSending || Number(specialOrderRemaining) !== 0 || (currentEditingOrderId ? !canEditOrder : !canAddOrder)"
                    class="w-full px-2 py-1 text-sm bg-green-600 text-white rounded-sm hover:bg-green-700 transition-colors tracking-wider disabled:bg-green-400 disabled:cursor-not-allowed disabled:hover:bg-green-400 flex items-center justify-center min-h-[32px]"
                    :title="Number(specialOrderRemaining) !== 0 ? 'Remaining must be 0 to confirm' : (currentEditingOrderId ? (!canEditOrder ? 'You do not have Edit privileges for Special Orders' : '') : (!canAddOrder ? 'You do not have Add privileges for Special Orders' : ''))"
                  >
                    <span v-if="isSending" class="h-4 w-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                    <span v-else>Confirm</span>
                  </button>
                </div>
  
                <!-- Second Row: Delivery Company & Code (Conditional) -->
                <div v-if="isDelivery" class="flex space-x-2">
                  <select 
                    v-model="deliveryCompany" 
                    class="flex-1 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                  >
                    <option value="" disabled>Delivery Company</option>
                    <option v-for="c in deliveryCompanies" :key="c.id" :value="String(c.id)">{{ c.name }}</option>
                  </select>
                  <input 
                    v-model="deliveryCode" 
                    type="text" 
                    placeholder="Code" 
                    class="w-20 text-sm border border-gray-300 rounded-sm py-1 px-2 focus:ring-1 focus:ring-blue-500 outline-none"
                  />
                </div>
  <!-- if user has privilege to approve order -->
                <!-- Third Row: Confirm Button -->
                <div v-if="canConfirmOrder && 1==3" class="w-full pt-1">
                  <button 
                    @click="confirmBill" 
                  
                    class="w-full px-2 py-1 text-sm bg-green-600 text-white rounded-sm hover:bg-green-700 transition-color tracking-wider disabled:bg-green-400 disabled:cursor-not-allowed disabled:hover:bg-green-400"
                  >
                    Confirm
                  </button>
                </div>
              </div>
              </div>
             
            </template>
  
            <!-- ALL ORDERS INLINE VIEW -->
            <template v-else>
              <div class="p-0">
                
                <table class="w-full">
                  <thead class="bg-gray-50 sticky top-0">
                    <tr class="text-[11px]">
                      <th class="py-1 px-0.5 border-b w-[22%]">Date</th>
                      <th class="py-1 px-0.5 border-b w-[20%]">Name</th>
                      <th class="py-1 px-0.5 border-b w-[12%] text-center">O. No</th>
                      <th class="py-1 px-0.5 border-b w-[12%] text-center">Table</th>
                      <th class="py-1 px-0.5 border-b w-[18%] text-right pr-1">TP</th>
                      <th class="py-1 px-0.5 border-b w-[8%]"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Today Orders -->
                    <tr 
                      v-for="order in todayOrders" 
                      :key="order.id" 
                      @click="viewOrder(order.id)"
                      class="hover:bg-yellow-200 cursor-pointer transition-colors text-[11px]"
                      :class="{
                        'bg-green-100/70 border-y border-green-300': order.transferStatus === 1,
                        'bg-orange-100/50': order.transferStatus === 0 && order.transferStatus !== 1 && !order.isAnyUnprinted
                      }"
                    >
                      <td class="py-1 px-0.5 border-b truncate">
                        <div class="flex items-center">
                          {{ order.createdAt ? order.createdAt.split('T')[0] : '---' }}
                        </div>
                      </td>
                      <td 
                        class="py-1 px-0.5 border-b truncate"
                        :class="{ 'text-red-600 font-bold italic': order.isAnyUnprinted }"
                      >{{ order.name || '---' }}</td>
                      <td class="py-1 px-0.5 border-b text-center align-middle">
                        <div class="flex items-center justify-center truncate">{{ order.dailyOrderNo ?? '---' }}</div>
                      </td>
                      <td class="py-1 px-0.5 border-b text-center align-middle">
                        <div class="flex items-center justify-center truncate">{{ String(order.table).length <=5 ? order.table || '---' : '---' }}</div>
                      </td>
                      <td class="py-1 px-0.5 border-b font-bold text-right pr-1 truncate">{{ (order.totalPriceSum || 0).toFixed(2) }}</td>
                      <td class="py-1 px-0.5 border-b text-center">
                        <svg v-if="order.hasPendingTransfer" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0d4169" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="inline-block">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </td>
                    </tr>
  
                    <!-- Before Today Title Row -->
                   <tr v-if="beforeTodayOrders.length > 0" class="text-center py-0">
    <td colspan="6"
        class="py-0 px-2 bg-[#db490b] border-y border-red-100 text-white font-bold  text-[13px] capitalize tracking-widest text-center align-middle">
      <div class="w-full text-center">
        Before Today Orders
      </div>
    </td>
  </tr>
  
                    <!-- Before Today Orders -->
                    <tr 
                      v-for="order in beforeTodayOrders" 
                      :key="order.id" 
                      @click="viewOrder(order.id)"
                      class="hover:bg-yellow-200 cursor-pointer transition-colors text-[11px]"
                      :class="{
                        'bg-green-100/70 border-y border-green-300': order.transferStatus === 1,
                        'bg-orange-100/50': order.transferStatus === 0 && order.transferStatus !== 1 && !order.isAnyUnprinted
                      }"
                    >
                      <td class="py-1 px-0.5 border-b truncate">
                        <div class="flex items-center">
                          {{ order.createdAt ? order.createdAt.split('T')[0] : '---' }}
                        </div>
                      </td>
                      <td 
                        class="py-1 px-0.5 border-b truncate"
                        :class="{ 'text-red-600 font-bold italic': order.isAnyUnprinted }"
                      >{{ order.name || '---' }}</td>
                      <td class="py-1 px-0.5 border-b text-center align-middle">
                        <div class="flex items-center justify-center truncate">{{ order.dailyOrderNo ?? '---' }}</div>
                      </td>
                      <td class="py-1 px-0.5 border-b text-center align-middle">
                        <div class="flex items-center justify-center truncate">{{ String(order.table).length <=5 ? order.table || '---' : '---' }}</div>
                      </td>
                      <td class="py-1 px-0.5 border-b font-bold text-right pr-1 truncate">{{ (order.totalPriceSum || 0).toFixed(2) }}</td>
                      <td class="py-1 px-0.5 border-b text-center">
                        <svg v-if="order.hasPendingTransfer" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0d4169" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="inline-block">
                          <polyline points="20 6 9 17 4 12"></polyline>
                        </svg>
                      </td>
                    </tr>
  
                    <tr v-if="orderGroups.length === 0" class="text-center">
                      <td colspan="6" class="py-4 text-center text-gray-500 italic">No orders found.</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  
    <!-- PAYMENT METHODS MODAL -->
  <Transition name="fade">
    <div v-if="showPaymentModal" class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
      <!-- Increased width to md for 4-column layout -->
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200">
        
        <!-- Compact Header -->
        <div class="px-4 py-3 flex justify-between items-center bg-[#0d4169]">
          <h3 class="text-sm font-bold text-white capitalize tracking-wide">Payment Methods</h3>
          <button @click="showPaymentModal = false" class="w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
        </div>
  
        <div class="p-4">
          <!-- Slim Amount Bar -->
          <div v-if="paymentPhase !== 'selection'" class="bg-slate-50 rounded-lg p-3 text-center mb-4 border border-slate-100">
            <span class="text-[10px] capitalize font-bold  tracking-wider">Total Amount</span>
            <div class="text-xl font-black text-[#0d4169] leading-none mt-1">
              {{ totalPrice }} 
            </div>
          </div>
  
          <!-- Phase 1: 4-Column Grid -->
          <div v-if="paymentPhase === 'selection'" class="pb-6">
            <div class="grid grid-cols-4 gap-2">
              <button 
                v-for="method in availablePaymentMethods" 
                :key="method.id"
                @click="handlePaymentSelection(method)"
                class="flex flex-col items-center justify-center p-3 border border-gray-200 rounded-lg hover:border-[#0d4169] hover:bg-blue-50/30 transition-all active:scale-95 bg-white group"
              >
                <div class="w-10 h-10 mb-1 group-hover:scale-110 transition-transform flex items-center justify-center overflow-hidden">
                  <img v-if="method.logo" :src="method.logo" class="w-full h-full object-contain rounded-md p-1 border border-slate-100 bg-slate-50/50 shadow-sm">
                  <div v-else class="w-10 h-10 rounded-md bg-slate-100 flex items-center justify-center text-sm font-black text-slate-400 uppercase border border-slate-200">
                    {{ method.name.substring(0, 2) }}
                  </div>
                </div>
                <span class="text-[10px] font-bold text-slate-600 capitalize text-center leading-tight">{{ method.name }}</span>
              </button>
            </div>
            <div v-if="availablePaymentMethods.length === 0" class="py-10 text-center text-slate-400 italic text-sm">
              No active payment methods.
            </div>
          </div>
  
          <!-- Phase 2: Condensed Details / Processing -->
          <div v-else class="animate-in slide-in-from-right-2 duration-200">
            <div v-if="isProcessingPayment" class="flex flex-col items-center justify-center py-8 space-y-4">
              <div v-if="paymentSimulationStatus === 'waiting'" class="flex flex-col items-center animate-pulse">
                <div class="text-4xl mb-3">🕒</div>
                <p class="text-orange-500 font-black text-lg text-center tracking-tight">Waiting customer payment...</p>
                <p class="text-[10px] text-slate-400 mt-2">Please wait while we verify the transaction</p>
              </div>
              <div v-if="paymentSimulationStatus === 'success'" class="flex flex-col items-center">
                <div class="text-4xl mb-3 animate-bounce">✅</div>
                <p class="text-green-600 font-black text-lg text-center tracking-tight">Customer paid successfully</p>
                <p class="text-[10px] text-slate-400 mt-2">Processing completed</p>
              </div>
            </div>
  
            <div v-else>
              <div class="flex items-center space-x-3 mb-4 bg-slate-50 p-2 rounded-lg border border-slate-100">
                 <div v-if="selectedPaymentMethod?.logo" class="w-8 h-8 rounded bg-white flex items-center justify-center overflow-hidden border border-slate-200">
                    <img :src="selectedPaymentMethod.logo" class="w-full h-full object-contain">
                 </div>
                 <div v-else class="w-8 h-8 rounded bg-white flex items-center justify-center text-xs font-bold text-slate-400 border border-slate-200 uppercase">
                    {{ selectedPaymentMethod?.name?.substring(0, 2) }}
                 </div>
                 <span class="text-sm font-bold text-[#0d4169] capitalize tracking-tight">{{ selectedPaymentMethod?.name }}</span>
              </div>
              
              <div class="space-y-4">
                <div class="flex flex-col items-start w-3/4 mx-auto">
                  <label class="pl-4 text-[11px] font-bold text-slate-500 capitalize tracking-wider mb-1.5">
                    Customer Phone Number
                  </label>
                  <input 
                    v-model="customerPhone"
                    type="text"
                    placeholder="09..."
                    class="w-full px-3 py-1.5 bg-gray-50 border border-gray-200 rounded text-left text-sm focus:bg-white focus:border-[#0d4169] outline-none font-bold transition-all placeholder:font-normal"
                    @keyup.enter="markPaid(selectedPaymentMethod)"
                    autofocus
                  />
                </div>
  
                <!-- Actions: Back (Left) & Pay Now (Right) -->
                <div class="flex items-center justify-between pt-3 border-t border-gray-100">
                  <button 
                    @click="paymentPhase = 'selection'" 
                    class="pl-1 text-[13px] font-bold hover:text-slate-600 transition-all capitalize tracking-tight flex items-center"
                  >
                    <span class="mr-1">←</span> Back
                  </button>
                  
                  <button 
                    @click="markPaid(selectedPaymentMethod)" 
                    :disabled="isSending"
                    class="px-5 py-2 bg-green-600 text-white rounded text-[11px] font-bold hover:bg-green-700 shadow-sm active:scale-95 transition-all capitalize tracking-wider flex items-center justify-center min-w-[70px] min-h-[36px]"
                  >
                    <span v-if="isSending" class="spinner"></span>
                    <span v-else>Send</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
    <!-- TRANSFER REQUESTS MODAL -->
    <Transition name="fade">
      <div v-if="showTransferModal" class="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
        <div class="bg-white rounded-xl shadow-2xl w-full max-w-2xl overflow-hidden animate-in zoom-in-95 duration-200">
          <!-- Modal Header -->
          <div class="px-5 py-3 flex justify-between items-center bg-[#0d4169]">
            <div>
              <h3 class="text-sm font-bold text-white tracking-wide">Transfer Requests</h3>
              <p class="text-[10px] text-white/70">{{ transferRequests.length }} pending request{{ transferRequests.length !== 1 ? 's' : '' }}</p>
            </div>
            <button @click="showTransferModal = false" class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
          </div>
  
          <!-- Cards Container -->
          <div class="p-4 max-h-[70vh] overflow-y-auto custom-scrollbar">
            <div v-if="transferRequests.length === 0" class="py-16 text-center text-gray-400 italic text-sm">
              No transfer requests pending.
            </div>
            <div v-else class="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div 
                v-for="req in transferRequests"
                :key="req.id"
                class="border border-gray-200 rounded-lg overflow-hidden bg-white shadow-sm flex flex-col"
              >
                <!-- Card Header -->
                <div class="bg-slate-50 border-b border-gray-200 px-3 py-2">
                  <div class="flex items-center justify-between">
                    <span class="text-[13px] font-bold text-[#0d4169] capitalize">{{ req.waiter }}</span>
                    <span class="text-[10px] text-slate-400">{{ req.date }}</span>
                  </div>
                  <div class="flex items-center mt-0.5 space-x-3">
                    <span class="text-[10px] text-slate-500">Table: <span class="font-bold text-slate-700">            {{ String(req.table).length <=5 ? req.table || '---' : '---' }}</span></span>
                    <span class="text-[10px] text-slate-500">{{ req.items.length }} item{{ req.items.length !== 1 ? 's' : '' }}</span>
                  </div>
                </div>
  
                <!-- Card Items Table -->
                <table class="w-full text-[11px] flex-1">
                  <thead class="bg-gray-50">
                    <tr>
                      <th class="py-1 px-2 border-b text-left w-[50%]">Menu</th>
                      <th class="py-1 px-2 border-b text-center w-[20%]">Qty</th>
                      <th class="py-1 px-2 border-b text-center w-[30%]">
                        <input type="checkbox" @change="toggleAllItems(req, $event.target.checked)" class="cursor-pointer" title="Select all" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in req.items" :key="item.id" class="hover:bg-blue-50/50 transition-colors">
                      <td class="py-1.5 px-2 border-b truncate">{{ item.menuName }}</td>
                      <td class="py-1.5 px-2 border-b text-center">{{ item.qty }}</td>
                      <td class="py-1.5 px-2 border-b text-center">
                        <input type="checkbox" v-model="item.selected" class="cursor-pointer" />
                      </td>
                    </tr>
                  </tbody>
                </table>
  
                <!-- Card Actions -->
                <div class="bg-gray-50 px-3 pl-2 py-2 border-t border-gray-100 flex flex-col space-y-2">
                  
                  <!-- Buttons at the top -->
                  <div class="flex justify-end space-x-2 border-b border-gray-100 pb-1 gap-7">
                    <button
                      @click="toggleTransferAction(req.id, true)"
                      class="px-3 py-1 text-[11px] font-bold border rounded transition-all bg-green-50 text-green-600 border-green-200 hover:bg-green-600 hover:text-white"
                    >
                      Accept
                    </button>
  
                    <button
                      @click="() => {
                        let selected = req.items.filter(i => i.selected).map(i => i.transferId)
                        if (selected.length === 0) selected = req.items.map(i => i.transferId)
                        if (selected.length && confirmAction('Are you sure you want to reject the selected items?')) {
                          rejectTransfer(selected.join(','), req.id)
                        }
                      }"
                      class="px-3 py-1 text-[11px] font-bold border rounded transition-all bg-red-50 text-red-600 border-red-200 hover:bg-red-600 hover:text-white"
                    >
                      Reject
                    </button>
                  </div>
  
                  <!-- Action section (Hidden by default) -->
                  <template v-if="transferUIState[req.id]?.showAction">
                    <!-- Choose Table View -->
                    <div v-if="!transferUIState[req.id].action || transferUIState[req.id].action === 'Merge'" class="w-full pt-1">
                      <span class="text-[11px] font-bold text-gray-500 block mb-1.5 text-left">Select existing table:</span>
                      <div class="flex flex-col w-full divide-y divide-gray-100 border-b border-gray-100 mb-2">
                        <button 
                          v-for="t in pendingTables" 
                          :key="t"
                          @click="transferUIState[req.id].action = 'Merge'; transferUIState[req.id].targetTable = t;"
                          :class="[
                            'px-3 py-2.5 text-[11px] font-bold transition-all w-full flex justify-between items-center',
                            transferUIState[req.id].action === 'Merge' && transferUIState[req.id].targetTable === t
                              ? 'bg-blue-600 text-white'
                              : 'bg-white text-gray-700 hover:bg-blue-50'
                          ]"
                        >
                          <span>Table Number</span>
                          <span>{{ String(t).length <=5 ? t || '---' : '---' }}</span>
                        </button>
                      </div>
                      <button 
                        @click="transferUIState[req.id].action = 'New Table'; transferUIState[req.id].targetTable = '';"
                        class="px-2 py-1 text-[11px] font-bold text-[#0d4169] hover:underline transition-all flex items-center justify-start"
                      >
                        <span class="mr-1 shrink-0 bg-[#0d4169]/10 text-[#0d4169] rounded-full w-4 h-4 flex flex-col justify-center items-center text-[10px] leading-none">+</span> New table
                      </button>
                    </div>
  
                    <!-- New Table Keypad (Numeric input) -->
                    <div v-if="transferUIState[req.id]?.action === 'New Table'" class="flex flex-col space-y-1">
                      <div class="flex items-center justify-between mb-1">
                        <span class="text-[11px] font-bold text-gray-500">New Table</span>
                        <button @click="transferUIState[req.id].action = ''; transferUIState[req.id].targetTable = '';" class="text-[10px] text-[#0d4169] hover:underline font-bold">← Back</button>
                      </div>
                      <div class="flex items-center justify-between border border-gray-200 rounded px-2 py-0.5 bg-white shadow-sm">
                          <span class="text-[15px] font-black text-[#0d4169]">Table: {{ transferUIState[req.id]?.targetTable || '---' }}</span>
                          <button @click="clearTransferTable(req.id)" class="text-red-500 text-sm hover:text-red-700 font-bold">×</button>
                      </div>
                      <!-- Keypad rows distributed across the whole row -->
                      <div class="grid grid-cols-5 gap-2 w-full">
                        <button 
                          v-for="n in [1, 2, 3, 4, 5]" 
                          :key="n"
                          @click="setTransferTableDigit(req.id, n)"
                          class="active:bg-[#1a5a8a] active:text-white w-full h-9 flex items-center justify-center border border-gray-200 text-[13px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
                        >
                          {{ n }}
                        </button>
                        <button 
                          v-for="n in [6, 7, 8, 9, 0]" 
                          :key="n"
                          @click="setTransferTableDigit(req.id, n)"
                          class="active:bg-[#1a5a8a] active:text-white w-full h-9 flex items-center justify-center border border-gray-200 text-[13px] font-black bg-gray-50 hover:bg-white text-gray-700 rounded shadow-sm hover:shadow active:translate-y-px transition-all"
                        >
                          {{ n }}
                        </button>
                      </div>
                    </div>
  
                    <!-- Final Confirmation Button to use acceptTransfer -->
                    <div v-if="transferUIState[req.id]?.action" class="pt-2 border-t border-gray-100 mt-2">
                      <button
                        @click="() => {
                          const dest = resolveTransferDestination(req.id)
                          if (!dest) return
                          let selected = req.items.filter(i => i.selected).map(i => i.transferId)
                          if (selected.length === 0) selected = req.items.map(i => i.transferId)
                          // const action = transferUIState[req.id]?.action
                          // const target = transferUIState[req.id]?.targetTable
                          // && confirmAction(`Accept transfer to ${action}: Table ${target}?`)
                          if (selected.length) {
                            acceptTransfer(selected.join(','), dest.tableNumber, dest.orderGroupId, req.id)
                          }
                        }"
                        class="w-full py-1 text-[11px] font-bold border rounded transition-all bg-green-600 text-white border-green-700 hover:bg-green-700 shadow-sm"
                      >
                        Confirm Accept
                      </button>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
  
          <!-- Modal Footer -->
          <div class="bg-gray-50 px-5 py-3 flex justify-end border-t border-gray-100">
            <button 
              @click="showTransferModal = false" 
              class="px-5 py-1.5 bg-[#0d4169] text-white rounded text-xs font-bold hover:bg-[#0a3354] transition-all"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </Transition>
    
    <!-- Toast Notification -->
    <Transition name="toast">
      <div v-if="toast.show" class="fixed top-4 right-4 z-[1000] max-w-sm">
        <div 
          :class="[
            'px-6 py-3 rounded-lg shadow-2xl text-white flex items-center gap-3 min-w-[300px]',
            toast.type === 'success' ? 'bg-green-600' : 'bg-red-600'
          ]"
        >
          <span v-if="toast.type == 'success'">✅</span>
          <span v-else>❌</span>
          <span class="font-medium">{{ toast.message }}</span>
        </div>
      </div>
    </Transition>

  <!-- TRANSACTION ID SCAN INPUTS -->
  <input ref="txnScanFileInput" type="file" accept="image/*" class="txn-scan-file-input" @change="handleTxnScanFile" />
  <input ref="txnScanCameraInput" type="file" accept="image/*" capture="environment" class="txn-scan-file-input" @change="handleTxnScanFile" />
  <Transition name="fade">
    <div
      v-if="showTxnScanSourcePicker"
      class="fixed inset-0 z-[110] flex items-end justify-center bg-slate-900/40"
      @click.self="closeTxnScanSourcePicker"
    >
      <div class="bg-white rounded-t-2xl shadow-2xl w-full max-w-md overflow-hidden px-4 pt-4 pb-6">
        <div :class="isCbePaymentSelected ? 'flex gap-3' : 'flex gap-3'">
          <button
            type="button"
            @click="pickTxnCameraFromSourcePicker"
            :disabled="isScanningTransaction"
            class="flex-1 flex flex-col items-center justify-center gap-2 p-3 rounded-xl border border-slate-200 bg-slate-50 active:scale-95 transition-all disabled:opacity-50"
          >
            <div class="w-11 h-11 rounded-full bg-[#0d4169]/10 flex items-center justify-center text-[#0d4169]">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path>
                <circle cx="12" cy="13" r="4"></circle>
              </svg>
            </div>
            <span class="text-[11px] font-bold text-slate-700">Camera</span>
          </button>
          <button
            type="button"
            @click="pickTxnGalleryFromSourcePicker"
            :disabled="isScanningTransaction"
            class="flex-1 flex flex-col items-center justify-center gap-2 p-3 rounded-xl border border-slate-200 bg-slate-50 active:scale-95 transition-all disabled:opacity-50"
          >
            <div class="w-11 h-11 rounded-full bg-[#0d4169]/10 flex items-center justify-center text-[#0d4169]">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                <circle cx="8.5" cy="8.5" r="1.5"></circle>
                <path d="M21 15l-5-5L5 21"></path>
              </svg>
            </div>
            <span class="text-[11px] font-bold text-slate-700">Gallery</span>
          </button>
          <button
            v-if="isCbePaymentSelected &&1==3"
            type="button"
            @click="pickTxnQrFromSourcePicker"
            :disabled="isScanningTransaction"
            class="flex-1 flex flex-col items-center justify-center gap-2 p-3 rounded-xl border border-slate-200 bg-slate-50 active:scale-95 transition-all disabled:opacity-50"
          >
            <div class="w-11 h-11 rounded-full bg-[#0d4169]/10 flex items-center justify-center text-[#0d4169]">
              <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="3" width="7" height="7"></rect>
                <rect x="14" y="3" width="7" height="7"></rect>
                <rect x="3" y="14" width="7" height="7"></rect>
                <path d="M14 14h.01"></path>
                <path d="M20 14h.01"></path>
                <path d="M14 20h.01"></path>
                <path d="M20 20h.01"></path>
                <path d="M17 17h.01"></path>
                <path d="M17 20h.01"></path>
                <path d="M20 17h.01"></path>
              </svg>
            </div>
            <span class="text-[11px] font-bold text-slate-700">QR Code</span>
          </button>
        </div>
      </div>
    </div>
  </Transition>
  <Transition name="fade">
    <div v-if="showTxnLiveCameraScan" class="fixed inset-0 z-[110] bg-black flex flex-col">
      <div class="px-4 py-3 flex justify-between items-center bg-[#0d4169] shrink-0">
        <h3 class="text-sm font-bold text-white tracking-wide">{{ txnLiveScanPurpose === 'qr' ? 'Scan QR Code' : 'Scan Transaction ID' }}</h3>
        <button type="button" @click="closeLiveTxnCameraScan" class="w-7 h-7 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
      </div>
      <div class="relative flex-1 min-h-0 bg-black">
        <video ref="txnLiveScanVideo" autoplay playsinline muted class="absolute inset-0 w-full h-full object-cover"></video>
        <div class="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/85 via-black/50 to-transparent">
          <p class="text-white text-xs font-medium text-center">{{ txnLiveScanPurpose === 'qr' ? 'Point your camera at the CBE receipt QR code' : 'Point your camera at the transaction ID' }}</p>
          <p class="text-white/75 text-[10px] text-center mt-1">Scanning automatically — hold steady</p>
          <p v-if="txnLiveScanProcessing" class="text-white/90 text-[10px] text-center mt-2 font-bold">Reading...</p>
        </div>
      </div>
    </div>
  </Transition>
  <Transition name="fade">
    <div v-if="showTxnScanModal" class="fixed inset-0 z-[110] flex items-center justify-center bg-slate-900/70 backdrop-blur-sm p-4">
      <div class="bg-white rounded-xl shadow-2xl w-full max-w-sm overflow-hidden relative">
        <div v-if="isScanningTransaction" class="absolute inset-0 z-20 bg-white/92 flex flex-col items-center justify-center gap-3">
          <span class="txn-scan-spinner-lg"></span>
          <p class="text-sm font-bold text-[#0d4169]">Scanning...</p>
          <p class="text-[11px] text-slate-500 px-6 text-center">Reading payment screen locally. No image is uploaded.</p>
        </div>

        <div class="px-4 py-3 flex justify-between items-center bg-[#0d4169]">
          <h3 class="text-sm font-bold text-white tracking-wide">Scan Transaction ID</h3>
          <button type="button" @click="closeTxnScanModal" class="w-6 h-6 flex items-center justify-center rounded-full hover:bg-white/10 text-white transition-all text-lg">&times;</button>
        </div>

        <div class="p-4 space-y-4">
          <div v-if="txnScanMode === 'chooser'" class="grid grid-cols-1 gap-3">
            <button
              type="button"
              @click="pickTxnScreenshot"
              :disabled="isScanningTransaction"
              class="w-full px-4 py-3 border border-slate-200 rounded-lg hover:border-[#0d4169] hover:bg-blue-50/40 transition-all text-left"
            >
              <div class="text-sm font-bold text-[#0d4169]">Upload Screenshot</div>
              <div class="text-[11px] text-slate-500 mt-0.5">Select a payment confirmation image from your device</div>
            </button>
            <button
              type="button"
              @click="startTxnCamera"
              :disabled="isScanningTransaction"
              class="w-full px-4 py-3 border border-slate-200 rounded-lg hover:border-[#0d4169] hover:bg-blue-50/40 transition-all text-left"
            >
              <div class="text-sm font-bold text-[#0d4169]">Use Camera</div>
              <div class="text-[11px] text-slate-500 mt-0.5">Point at another phone's payment screen and capture</div>
            </button>
          </div>

          <div v-else class="space-y-3">
            <video ref="txnScanVideo" autoplay playsinline muted class="w-full rounded-lg border border-slate-200 bg-black max-h-52 object-cover"></video>
            <div class="flex items-center justify-between gap-2">
              <button type="button" @click="txnScanMode = 'chooser'; stopTxnCamera()" class="text-[12px] font-bold text-slate-500 hover:text-slate-700">Back</button>
              <button
                type="button"
                @click="captureAndScanTransaction"
                :disabled="isScanningTransaction"
                class="px-4 py-2 bg-[#0d4169] text-white rounded text-[11px] font-bold hover:bg-[#0a3354] active:scale-95 transition-all disabled:opacity-50"
              >
                Capture &amp; Scan
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
  
  </template>
  
  <script setup>
  import { ref, computed, onMounted, onUnmounted, watch, nextTick } from 'vue'
  import store from '../../store'
  import { apiFetch, WS_BASE_URL, resolveCompanyLogoUrl } from '../../utils/api'
  import { usePaymentTxnScan } from '../../utils/paymentTxnScan'
  import { jsPDF } from 'jspdf'

  function activateOpenPriceMode() {
    clearBillAreaOnly()
    isOpenPriceMode.value = true
    viewMode.value = 'bill'
    openPriceItemName.value = ''
    openPriceQty.value = ''
    openPriceUnitPrice.value = ''
    resetSpecialOrderPaymentInputs()
    specialOrderPaymentHistory.value = []
    specialOrderItemImage.value = ''
    specialOrderRemark.value = ''
  }
  
  // Helper for template to use window.confirm
  const confirmAction = (msg) => window.confirm(msg)
  
  
  const currentUser = computed(() => store.getters.currentUser)
  // Used by transfer checkboxes (currently commented out in bill list)
  // const isAdmin = computed(() => currentUser.value?.role === 'Admin')
  
  const userPrivileges = computed(() => {
    if (!currentUser.value?.privilege) return {}
    return typeof currentUser.value.privilege === 'string' 
      ? JSON.parse(currentUser.value.privilege) 
      : currentUser.value.privilege
  })
  
  const hasAdminPrivilege = computed(() => {
    return userPrivileges.value?.All === true || userPrivileges.value?.all === true
  })

  function getPrivilegeBlock(name) {
    return userPrivileges.value?.[name] || userPrivileges.value?.[String(name).toLowerCase()] || null
  }

  const specialOrdersPrivilege = computed(() => getPrivilegeBlock('Special Orders'))
  
  const canAddOrder = computed(() => {
    if (hasAdminPrivilege.value) return true
    return !!specialOrdersPrivilege.value?.Add
  })
  
  const canEditOrder = computed(() => {
    if (hasAdminPrivilege.value) return true
    return !!specialOrdersPrivilege.value?.Edit
  })
  
  const canViewAllOrders = computed(() => {
    if (hasAdminPrivilege.value) return true
    return !!specialOrdersPrivilege.value?.View
  })
  
  const isWaiterRole = computed(() => {
    const role = currentUser.value?.role
    if (!role) return false
    return String(role).split(',').map(r => r.trim().toLowerCase()).includes('waiter')
  })
  
  const ordersButtonLabel = computed(() => isWaiterRole.value ? 'All orders' : 'All orders')
  
  const canVoidOrder = computed(() => {
    if (hasAdminPrivilege.value) return true
    return !!specialOrdersPrivilege.value?.Void
  })
  
  const canConfirmOrder = computed(() => {
    if (hasAdminPrivilege.value) return true
    // Special Orders Confirm column in UserModal is stored as Approve; keep Confirm fallback
    return !!(specialOrdersPrivilege.value?.Confirm ?? specialOrdersPrivilege.value?.Approve)
  })
  
  // const canClickConfirmBill = computed(() => {
  //   if (billItems.value.length === 0) return false
  //   return billItems.value.every(item =>
  //     (item.transferredNotPrintedCount || 0) === 0 && (item.ownNotPrintedCount || 0) === 0
  //   )
  // })
  
  // Check if currently editing an order that belongs strictly to the user
  const isOwnOrder = computed(() => {
    if (!currentEditingOrderId.value) return true // New orders belong to user
    const order = orderGroups.value.find(o => o.id === currentEditingOrderId.value)
    if (!order) return false
    const uid = currentUser.value?.id || currentUser.value?.sub
    return order.waiterId === uid
  })
  
  const companyId = computed(() => currentUser.value?.companyId || currentUser.value?.company_id || null)
  const branchId = computed(() => currentUser.value?.branchId || currentUser.value?.branch_id || null)
  const companyName = computed(() => currentUser.value?.company?.name || '')
  const printCompanyName = computed(() =>
    currentUser.value?.company?.name ||
    currentUser.value?.companyName ||
    currentUser.value?.company_name ||
    'Company'
  )
  const printCompanyLogo = computed(() =>
    resolveCompanyLogoUrl(
      currentUser.value?.company?.logo_url ||
      currentUser.value?.companyLogo ||
      currentUser.value?.company_logo ||
      ''
    )
  )
    
  const departments = ref([])
  const menus = ref([])
  const searchTerm = ref('')
  const selectedDept = ref(null)
  const selectedSub = ref(null)
  
  // Toast notification state
  const toast = ref({ show: false, message: '', type: 'success' })
  
  // Toast helper function
  function showToast(message, type = 'success', duration = 3000) {
    toast.value = { show: true, message, type }
    setTimeout(() => {
      toast.value.show = false
    }, duration)
  }
  
  function isStatusOn(v) {
    if (v === undefined || v === null) return false
    if (v === 1 || v === true) return true
    if (typeof v === 'string') return v.toLowerCase() === 'on' || v === '1' || v.toLowerCase() === 'active'
    if (typeof v === 'number') return v === 1
    return false
  }
  
  async function loadDepartments() {
    if (!companyId.value) {
      alert('Company ID not found in user profile.')
      return
    }
  
    try {
      let endpoint = `/departments/company/${companyId.value}`
      if (branchId.value) {
        endpoint = `/departments/branch/${branchId.value}`
      }
      
      const response = await apiFetch(endpoint, { method: 'GET' })
      if (!response.ok) {
        const data = await response.json().catch(() => ({}))
        throw new Error(data.message || 'Failed to load departments')
      }
      const data = await response.json()
      // POS: Only show active departments (status ON/1) that have printerIP.
      // Also filter subDepartments by active status if present.
      departments.value = (Array.isArray(data) ? data : [])
        .filter(d => d?.printerIP)
        .filter(d => isStatusOn(d?.status ?? d?.isActive ?? d?.is_active))
        .map(d => ({
          ...d,
          subDepartments: Array.isArray(d?.subDepartments)
            ? d.subDepartments
                .filter(sd => isStatusOn(sd?.status ?? sd?.isActive ?? sd?.is_active))
                .slice()
                .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' }))
            : d?.subDepartments
        }))
      departments.value = departments.value
        .filter(d => d.status === 1)
        .slice()
        .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', undefined, { sensitivity: 'base' }))
      // console.log('POS departments loaded (filtered by printerIP):', departments.value)
    } catch (err) {
      alert(err.message || 'Failed to load departments')
    } 
  }
  
  // Load all menus once, filtered by company/branch (backend: /menu-lists)
  async function loadMenus() {
    if (!companyId.value && !branchId.value) return
    try {
      const params = new URLSearchParams()
      if (branchId.value) params.append('branchId', branchId.value)
      else if (companyId.value) params.append('companyId', companyId.value)
  
      const response = await apiFetch(`/menu-lists?${params.toString()}`, { method: 'GET' })
      if (!response.ok) {
        console.error('Failed to load menus')
        return
      }
      const data = await response.json().catch(() => [])
      const list = Array.isArray(data) ? data : []
      menus.value = list.map((m) => {
        const totalPrice = Number(m.totalPrice ?? m.total_price ?? 0) || 0
        const originalPrice = Number(m.price ?? 0) || 0
        const addition = Number(m.addition ?? 0) || 0
        const vat = Number(m.vat ?? 0) || 0
        return {
          ...m,
          totalPrice,
          total_price: totalPrice,
          price: originalPrice,
          addition,
          vat
        }
      })
    } catch (err) {
      console.error('Error loading menus:', err)
    }
  }
  
  onMounted(() => {
    loadDepartments()
    loadMenus()
    loadPaymentMethods()
    loadDeliveryCompanies()
    loadTableMandatorySetting()
  })
  const billItems = ref([])
  const printFailures = ref([])
  const tableNumber = ref('')
  const tableError = ref(false)
  const isTableMandatory = ref(1)
  const orders = ref([])
  const viewMode = ref('bill') // 'bill' or 'orders'
  const currentEditingOrderId = ref(null)
  const originalWaiterId = ref(null)
  const selectedWaiter = ref('')
  const selectedOrderDate = ref('')
  const ordersScheduleFilterDate = ref('')
  const isDelivery = ref(false)
  const deliveryCompany = ref('')
  const deliveryCode = ref('')
  const deliveryCompanies = ref([])
  const specialOrderName = ref('')
  const specialOrderPhone = ref('')
  const specialOrderScheduleDate = ref('')
  const specialOrderAdvancePayment = ref('')
  const specialOrderPaymentType = ref('')
  const specialOrderRefNumber = ref('')
  const specialOrderPaymentHistory = ref([])
  const specialOrderItemImage = ref('')
  const specialOrderRemark = ref('')
  const isOpenPriceMode = ref(false)
  const openPriceItemName = ref('')
  const openPriceQty = ref('')
  const openPriceUnitPrice = ref('')
  const isUploadingItemImage = ref(false)
  
  const showPaymentModal = ref(false)
  const paymentPhase = ref('selection') // 'selection' or 'details'
  const billContainer = ref(null)
  
  function scrollToBottom() {
    if (billContainer.value) {
      billContainer.value.scrollTop = billContainer.value.scrollHeight
    }
  }
  const paymentMethods = ref([])
  
  const availablePaymentMethods = computed(() => {
    if (!isDelivery.value || !deliveryCompany.value) {
      return paymentMethods.value.filter(m => m.name.toLowerCase() !== 'delivery')
    }
    return paymentMethods.value
  })

  const showSpecialOrderRefNumber = computed(() => {
    const name = String(specialOrderPaymentType.value || '').trim().toLowerCase()
    return !!name && name !== 'cash'
  })

  const showSpecialOrderRefScan = computed(() => {
    const name = String(specialOrderPaymentType.value || '').trim().toLowerCase()
    return !!name && name !== 'cash' && name !== 'delivery'
  })

  function extractCbeReceiptUrl(content) {
    const text = String(content || '').trim()
    const candidate = text.match(/https?:\/\/[^\s]+/i)?.[0] || text
    try {
      const url = new URL(candidate.replace(/[),.;]+$/, ''))
      if (url.protocol !== 'https:' || url.hostname.toLowerCase() !== 'mbreciept.cbe.com.et') return ''
      return url.toString()
    } catch (_) {
      return ''
    }
  }

  function formatCbeScanAmount(amount) {
    if (amount == null || amount === '') return ''
    const numeric = Number(String(amount).replace(/,/g, '').replace(/[^\d.-]/g, ''))
    return Number.isFinite(numeric)
      ? numeric.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      : String(amount)
  }

  function formatCbeScanDate(value) {
    if (!value) return ''
    const parsed = new Date(value)
    return Number.isNaN(parsed.getTime())
      ? String(value)
      : parsed.toLocaleString([], { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
  }

  function isCbePaymentMethod(value) {
    return /\bcbe\b|commercial\s*bank|bank\s*of\s*ethiopia/i.test(String(value || ''))
  }

  async function resolveSpecialOrderCbeQr(qrContent) {
    if (!isCbePaymentMethod(specialOrderPaymentType.value)) return null
    const receiptUrl = extractCbeReceiptUrl(qrContent)
    if (!receiptUrl) return null
    const response = await apiFetch('/cbe/receipt', {
      method: 'POST',
      body: JSON.stringify({ url: receiptUrl }),
    })
    const data = await response.json().catch(() => ({}))
    if (!response.ok) throw new Error(data.message || `Failed to read CBE receipt (${response.status})`)
    const transactionId = String(data.transactionId || data.reference || data.vatReceiptNo || '').trim()
    if (!transactionId) throw new Error('CBE receipt did not include a Transaction ID')
    const receiverDisplay = [
      data.receiverName ? `Receiver: ${data.receiverName}` : '',
      data.amount ? `Amount: ${formatCbeScanAmount(data.amount)}` : '',
      data.receiverAccountLast4 ? `Account: ****${data.receiverAccountLast4}` : '',
      data.transactionDate ? `Transaction Date: ${formatCbeScanDate(data.transactionDate)}` : '',
    ].filter(Boolean).join('\n')
    return { extracted: transactionId, receiverDisplay }
  }

  const {
    scannedReceiverDisplay,
    isCbePaymentSelected,
    showTxnScanModal,
    showTxnScanSourcePicker,
    showTxnLiveCameraScan,
    isScanningTransaction,
    txnLiveScanProcessing,
    txnLiveScanPurpose,
    txnScanMode,
    txnScanFileInput,
    txnScanCameraInput,
    txnScanVideo,
    txnLiveScanVideo,
    openTxnScanPicker,
    closeTxnScanModal,
    closeTxnScanSourcePicker,
    closeLiveTxnCameraScan,
    pickTxnCameraFromSourcePicker,
    pickTxnGalleryFromSourcePicker,
    pickTxnQrFromSourcePicker,
    pickTxnScreenshot,
    startTxnCamera,
    captureAndScanTransaction,
    handleTxnScanFile,
    stopTxnCamera,
    cleanupPaymentTxnScan,
  } = usePaymentTxnScan({
    getPaymentMethod: () => specialOrderPaymentType.value,
    onApplyScan: (extracted) => {
      specialOrderRefNumber.value = extracted
    },
    onQrContent: resolveSpecialOrderCbeQr,
    showToast,
  })

  function handleSpecialOrderPaymentTypeChange() {
    if (isCbePaymentSelected.value) {
      nextTick(() => pickTxnQrFromSourcePicker())
    }
  }

  watch(specialOrderPaymentType, () => {
    scannedReceiverDisplay.value = ''
    closeTxnScanModal()
    closeLiveTxnCameraScan()
  })

  const specialOrderItemImageUrl = computed(() => resolveCompanyLogoUrl(specialOrderItemImage.value))

  async function onSpecialOrderImageSelect(event) {
    const file = event?.target?.files?.[0]
    if (!file) return
    if (isUploadingItemImage.value) return
    isUploadingItemImage.value = true
    try {
      const formData = new FormData()
      formData.append('logo', file)
      const res = await apiFetch('/upload', {
        method: 'POST',
        body: formData,
      })
      if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        throw new Error(err.message || 'Image upload failed')
      }
      const data = await res.json()
      specialOrderItemImage.value = data.filename || data.url || ''
      showToast('Image uploaded', 'success')
    } catch (err) {
      console.error('Special order image upload failed:', err)
      showToast(err.message || 'Image upload failed', 'error')
    } finally {
      isUploadingItemImage.value = false
      if (event?.target) event.target.value = ''
    }
  }

  function clearSpecialOrderImage() {
    specialOrderItemImage.value = ''
  }

  function resetSpecialOrderPaymentInputs() {
    specialOrderAdvancePayment.value = ''
    specialOrderPaymentType.value = ''
    specialOrderRefNumber.value = ''
    scannedReceiverDisplay.value = ''
    closeTxnScanModal()
    closeLiveTxnCameraScan()
  }

  function resetOpenPriceFields() {
    isOpenPriceMode.value = false
    openPriceItemName.value = ''
    openPriceQty.value = ''
    openPriceUnitPrice.value = ''
  }

  function resetSpecialOrderExtraFields() {
    resetSpecialOrderPaymentInputs()
    resetOpenPriceFields()
    specialOrderPaymentHistory.value = []
    specialOrderItemImage.value = ''
    specialOrderRemark.value = ''
  }

  function buildLocalPaymentEntry(amount) {
    return {
      amount,
      paymentType: specialOrderPaymentType.value || null,
      refNumber: showSpecialOrderRefNumber.value ? (specialOrderRefNumber.value || null) : null,
      paymentDate: new Date().toISOString(),
      waiterId: currentUser.value?.id || currentUser.value?.sub || null,
    }
  }

  function sumPaymentHistoryAmount(history) {
    if (!Array.isArray(history)) return 0
    return history.reduce((sum, row) => sum + (Number(row?.amount) || 0), 0)
  }

  function getImageFormatFromDataUrl(dataUrl) {
    if (!dataUrl || typeof dataUrl !== 'string') return 'PNG'
    if (dataUrl.startsWith('data:image/jpeg') || dataUrl.startsWith('data:image/jpg')) return 'JPEG'
    if (dataUrl.startsWith('data:image/webp')) return 'WEBP'
    return 'PNG'
  }

  async function imageUrlToDataUrl(url) {
    if (!url) return { dataUrl: null, format: 'PNG' }
    try {
      const res = await fetch(url)
      if (!res.ok) return { dataUrl: null, format: 'PNG' }
      const blob = await res.blob()
      const dataUrl = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onloadend = () => resolve(reader.result)
        reader.onerror = reject
        reader.readAsDataURL(blob)
      })
      return {
        dataUrl,
        format: getImageFormatFromDataUrl(dataUrl)
      }
    } catch {
      return { dataUrl: null, format: 'PNG' }
    }
  }

  function buildSpecialOrderBillPrintSnapshot({
    orderGroupId,
    advanceNum,
    payloadGrandTotal,
    remainingNum,
    openPriceName,
    openPriceQtyNum,
    openPriceUnitNum,
  }) {
    let rows = []
    if (isOpenPriceMode.value) {
      const qty = openPriceQtyNum
      const unitPrice = openPriceUnitNum
      rows = [{
        name: openPriceName || 'Item',
        qty,
        unitPrice,
        total: qty * unitPrice,
      }]
    } else {
      rows = billItems.value.map((item) => {
        const qty = Number(item.qty) || 0
        const unitPrice = Number(
          item.menu?.totalPrice ??
          item.menu?.total_price ??
          item.unitPrice ??
          item.unit_price ??
          0
        )
        return {
          name: item.menu?.name || item.itemName || 'Item',
          qty,
          unitPrice,
          total: qty * unitPrice,
        }
      })
    }

    const historyPaid = sumPaymentHistoryAmount(specialOrderPaymentHistory.value)
    const totalAdvance = historyPaid + (Number(advanceNum) || 0)
    const grandTotal = Number(payloadGrandTotal) || 0
    const remaining = Number.isFinite(Number(remainingNum))
      ? Number(remainingNum)
      : Math.max(0, grandTotal - totalAdvance)

    return {
      rows,
      totals: {
        grandTotal,
        advancePayment: totalAdvance,
        remaining,
      },
      meta: {
        orderId: orderGroupId,
        customerName: String(specialOrderName.value || '').trim(),
        customerPhone: String(specialOrderPhone.value || '').trim(),
        paymentType: String(specialOrderPaymentType.value || '').trim(),
        refNumber: showSpecialOrderRefNumber.value ? String(specialOrderRefNumber.value || '').trim() : '',
        scheduleDate: String(specialOrderScheduleDate.value || '').trim(),
        transactionDate: new Date().toLocaleDateString(),
      },
    }
  }

  async function generateSpecialOrderBillPdf(snapshot = null) {
    const rows = Array.isArray(snapshot?.rows) ? snapshot.rows : []
    if (!rows.length) return

    const totals = snapshot?.totals || {}
    const meta = snapshot?.meta || {}
    const thermalWidth = 80
    const leftMargin = 4
    const rightMargin = 4
    const contentWidth = thermalWidth - leftMargin - rightMargin
    const lineGap = 3.5
    const headerBottomY = 28

    const metaLineCount = (meta.customerName ? 1 : 0)
      + (meta.customerPhone ? 1 : 0)
      + (meta.scheduleDate ? 1 : 0)
      + (meta.paymentType ? 1 : 0)
      + (meta.refNumber ? 1 : 0)
    const estimatedHeight = headerBottomY + 8 + (metaLineCount * lineGap) + (rows.length * 11) + 28
    const pageHeight = Math.max(140, estimatedHeight)

    const doc = new jsPDF({ unit: 'mm', format: [thermalWidth, pageHeight], orientation: 'portrait' })
    const pageWidth = () => doc.internal.pageSize.getWidth()
    const pageHeightFn = () => doc.internal.pageSize.getHeight()
    let y = 6
    const today = meta.transactionDate || new Date().toLocaleDateString()
    const { dataUrl: logoDataUrl, format: logoFormat } = await imageUrlToDataUrl(String(printCompanyLogo.value || '').trim())

    const drawHeader = () => {
      const w = pageWidth()
      if (logoDataUrl) {
        doc.addImage(logoDataUrl, logoFormat, leftMargin, 6, 12, 9, undefined, 'FAST')
      }
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(10)
      doc.text(String(printCompanyName.value || 'Company'), w / 2, 9, { align: 'center' })
      doc.setFontSize(9)
      doc.text('Special Order Bill', w / 2, 14, { align: 'center' })
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(7)
      doc.text(`Date: ${today}`, w - rightMargin, 18, { align: 'right' })
      doc.setDrawColor(0, 0, 0)
      doc.setLineWidth(0.2)
      doc.line(leftMargin, headerBottomY, w - rightMargin, headerBottomY)
    }

    const ensureSpace = (needed) => {
      if (y + needed > pageHeightFn() - 6) {
        doc.addPage([thermalWidth, pageHeight])
        drawHeader()
        y = headerBottomY + 4
      }
    }

    drawHeader()
    y = headerBottomY + 4

    doc.setFont('helvetica', 'normal')
    doc.setFontSize(7)

    const printMetaLine = (label, value) => {
      if (!value) return
      ensureSpace(lineGap + 1)
      doc.text(`${label}: ${value}`, leftMargin, y)
      y += lineGap
    }

    printMetaLine('Customer', meta.customerName)
    printMetaLine('Phone', meta.customerPhone)
    printMetaLine('Schedule Date', meta.scheduleDate)
    printMetaLine('Payment Type', meta.paymentType)
    printMetaLine('Ref Number', meta.refNumber)

    ensureSpace(4)
    doc.line(leftMargin, y, pageWidth() - rightMargin, y)
    y += 4

    rows.forEach((row, idx) => {
      ensureSpace(12)
      doc.setFont('helvetica', 'bold')
      doc.setFontSize(8)
      const nameLines = doc.splitTextToSize(String(row.name || 'Item'), contentWidth)
      doc.text(nameLines, leftMargin, y)
      y += nameLines.length * 3.2

      doc.setFont('helvetica', 'normal')
      doc.setFontSize(7)
      doc.text(
        `Qty: ${row.qty}    Unit: ${Number(row.unitPrice || 0).toFixed(2)}    Total: ${Number(row.total || 0).toFixed(2)}`,
        leftMargin,
        y
      )
      y += 4

      if (idx < rows.length - 1) {
        doc.setLineWidth(0.1)
        doc.line(leftMargin, y, pageWidth() - rightMargin, y)
        y += 3
      }
    })

    ensureSpace(14)
    doc.setLineWidth(0.2)
    doc.line(leftMargin, y, pageWidth() - rightMargin, y)
    y += 5

    const valueX = pageWidth() - rightMargin
    const printTotalLine = (label, value, bold = false) => {
      ensureSpace(5)
      doc.setFont('helvetica', bold ? 'bold' : 'normal')
      doc.setFontSize(8)
      doc.text(`${label}:`, leftMargin, y)
      doc.text(Number(value || 0).toFixed(2), valueX, y, { align: 'right' })
      y += 4.5
    }

    printTotalLine('Grand Total', totals.grandTotal, true)
    printTotalLine('Advance Payment', totals.advancePayment)
    printTotalLine('Remaining', totals.remaining, true)

    const safeOrderId = String(meta.orderId || 'order').replace(/[\\/:*?"<>|]/g, '-').trim()
    const safeDate = new Date().toISOString().slice(0, 10).replace(/[\\/:*?"<>|]/g, '-')
    doc.save(`SpecialOrder-${safeOrderId}-${safeDate}.pdf`)
  }
  
  async function loadPaymentMethods() {
    try {
      const res = await apiFetch('/settings/payment-methods')
      if (res.ok) {
        const data = await res.json()
        // Only show active payment methods
        paymentMethods.value = data.filter(m => isStatusOn(m.isActive ?? m.is_active ?? m.status))
      }
    } catch (err) {
      console.error('Error loading payment methods:', err)
    }
  }
  
  async function loadDeliveryCompanies() {
    try {
      const res = await apiFetch('/settings/delivery-companies')
      if (res.ok) {
        const data = await res.json()
        // Only show active delivery companies
        deliveryCompanies.value = data.filter(c => c.isActive === 1)
      }
    } catch (err) {
      console.error('Error loading delivery companies:', err)
    }
  }
  
  function resolveDeliveryCompanySelection(raw) {
    if (raw == null || raw === '') return ''
    const value = String(raw)
    const byId = deliveryCompanies.value.find(c => String(c.id) === value)
    if (byId) return String(byId.id)
    const byName = deliveryCompanies.value.find(c => c.name === value)
    if (byName) return String(byName.id)
    return value
  }
  
  async function loadTableMandatorySetting() {
    try {
      const res = await apiFetch('/settings')
      if (!res.ok) return
      const data = await res.json()
      isTableMandatory.value = Number(data?.is_table_mandatory ?? 1) === 1 ? 1 : 0
    } catch (err) {
      console.error('Failed to read table mandatory setting:', err)
    }
  }
  
  const selectedPaymentMethod = ref(null)
  const customerPhone = ref('')
  const isProcessingPayment = ref(false)
  const paymentSimulationStatus = ref('waiting') // 'waiting' or 'success'
  
  const showTransferModal = ref(false)
  const isSending = ref(false)
  const transferRequests = ref([])
  const transferUIState = ref({}) // { [requestId]: { action: 'Merge' | 'New Table', targetTable: string } }
  const waiters = ref([])
  const selectedWaiterId = ref('')
  const transferBadgeCount = computed(() => transferRequests.value.length)
  
  const pendingTables = computed(() => {
    if (!Array.isArray(orderGroups.value)) return []
    
    const uid = currentUser.value?.id || currentUser.value?.sub
    const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD
    
    // Strictly filter for the current user's own tables. 
    // When accepting a transfer, the user should only merge into their own active tables.
    const filteredGroups = orderGroups.value.filter(g => {
      if (!g.table) return false
      const orderDate = g.createdAt ? String(g.createdAt).split('T')[0] : ''
      if (orderDate !== today) return false
      return String(g.waiterId) === String(uid)
    })
  
    const tables = filteredGroups.map(g => g.table)
    return [...new Set(tables)].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }))
  })
  
  function setTransferTableDigit(reqId, digit) {
    if (!transferUIState.value[reqId]) {
      transferUIState.value[reqId] = { action: 'New Table', targetTable: '' }
    }
    transferUIState.value[reqId].targetTable += digit.toString()
  }
  
  function clearTransferTable(reqId) {
    if (transferUIState.value[reqId]) {
      transferUIState.value[reqId].targetTable = ''
    }
  }
  
  function toggleTransferAction(reqId, state) {
    if (transferUIState.value[reqId]) {
      transferUIState.value[reqId].showAction = state
    }
  }
  
  async function loadWaiters() {
    try {
      const endpoint = branchId.value ? `/users/branch/${branchId.value}` : `/users/company/${companyId.value}`
      const response = await apiFetch(endpoint)
      if (response.ok) {
        waiters.value = await response.json()
        waiters.value = waiters.value.filter(w => w.status === 1);
        waiters.value = waiters.value.filter(w => w.role.toLowerCase().includes('waiter'));
      }
    } catch (err) {
      console.error('Failed to load waiters', err)
    }
  }
  
  function getOrderUpdatedAtForGroup(orderGroupId = currentEditingOrderId.value) {
    const group = orders.value.find(order => String(order.id) === String(orderGroupId))
    if (!group || !Array.isArray(group.items)) return []
    return group.items
      .map(item => ({ id: item.itemId ?? item.id, updatedAt: item.updatedAt }))
      .filter(item => item.id != null && typeof item.updatedAt === 'string')
  }

  async function transferSelectedItems() {
    const selectedOrderIds = billItems.value
      .filter(item => item.selected && item.orderId)
      .flatMap(item => {
        const ids = []
        if (item.itemId) ids.push(item.itemId)
        if (item.transferredItemId) ids.push(item.transferredItemId)
        return ids
      });
  
    if (selectedOrderIds.length === 0) {
      showToast('No saved items selected for transfer', 'error');
      return;
    }
    if (!selectedWaiterId.value) {
      showToast('Please select a waiter', 'error');
      return;
    }
  
    try {
      const response = await apiFetch('/order-transfers/bulk', {
        method: 'POST',
        body: JSON.stringify({
          senderId: currentUser.value.id,
          receiverId: selectedWaiterId.value,
          orderIds: selectedOrderIds,
          orderUpdatedAt: getOrderUpdatedAtForGroup(),
        })
      });
  
      if (response.ok) {
        showToast('Transfer request sent successfully', 'success');
        selectedWaiterId.value = '';
        
        // Do not remove items immediately; just uncheck them so they remain in the list until accepted
        billItems.value.forEach(item => { 
          if (item.selected) item.selected = false; 
        });
  
        // Refresh orders
        await fetchOrders(false);
        clearBillAreaOnly()
        // If bill is empty, clear it
        if (billItems.value.length === 0) {
          clearBill(true);
        }
      } else {
        const errorData = await response.json().catch(() => ({}))
        showToast(errorData.message || 'Failed to create transfer request', 'error');
      }
    } catch (err) {
      console.error('Transfer failed', err);
      showToast('Transfer failed', 'error');
    }
  }
  
  
  
  function toggleAllItems(req, checked) {
    req.items.forEach(item => { item.selected = checked })
  }
  
  async function fetchTransferRequests() {
    try {
      const response = await apiFetch(`/order-transfers?receiverId=${currentUser.value?.id}`)
      if (response.ok) {
        const data = await response.json()
        // Preserve local selections and initialize UI state
        data.forEach(req => {
          const existingReq = transferRequests.value.find(r => r.id === req.id)
          if (existingReq && existingReq.items) {
            req.items.forEach(newItem => {
              const existingItem = existingReq.items.find(i => i.transferId === newItem.transferId)
              if (existingItem && existingItem.selected) {
                newItem.selected = existingItem.selected
              }
            })
          }
          if (!transferUIState.value[req.id]) {
            transferUIState.value[req.id] = { action: '', targetTable: '', showAction: false }
          }
        })
        transferRequests.value = data
      }
    } catch (error) {
      console.error('Failed to fetch transfers:', error)
    }
  }
  
  async function acceptTransfer(transferIdString, tableNumber = null, orderGroupId = null, reqId = null) {
    try {
      const body = { isAccepted: 1, receiverId: currentUser.value?.id }
      if (tableNumber) body.tableNumber = tableNumber
      if (orderGroupId) body.orderGroupId = orderGroupId
      const request = transferRequests.value.find(item => String(item.id) === String(reqId))
      body.orderUpdatedAt = request?.orderUpdatedAt || []
  
      const response = await apiFetch(`/order-transfers/${transferIdString}/status`, {
        method: 'PATCH',
        body: JSON.stringify(body)
      })
      if (response.ok) {
        showToast('Transfer accepted', 'success')
        // Clear specify UI state to close the action drawer
        if (reqId) {
          delete transferUIState.value[reqId]
        }
        await fetchTransferRequests()
        if(transferRequests.value.length === 0){ showTransferModal.value = false}
        await fetchOrders()
      } else {
        const errorData = await response.json().catch(() => ({}))
        showToast(errorData.message || 'Failed to accept transfer', 'error')
      }
    } catch (error) {
      console.error('Accept transfer failed:', error)
      showToast('Failed to accept transfer', 'error')
    }
  }
  
  // Resolve destination params for a transfer request base on action
  function resolveTransferDestination(reqId) {
    const state = transferUIState.value[reqId]
    if (!state) return null
  
    const action = state.action
    const targetTable = state.targetTable
  
    if (action === 'Merge') {
      if (!targetTable) {
        showToast('Please select an existing table', 'error')
        return null
      }
      // Find the orderGroupId of the selected table (STRICT: today + current user + same table)
      const uid = currentUser.value?.id || currentUser.value?.sub
      const today = new Date().toISOString().split('T')[0] // YYYY-MM-DD
      const matchingOrder = orderGroups.value.find(o => {
        const orderDate = o?.createdAt ? String(o.createdAt).split('T')[0] : ''
        return (
          String(o?.table) === String(targetTable) &&
          String(o?.waiterId) === String(uid) &&
          orderDate === today
        )
      })
      if (!matchingOrder) {
        showToast('Selected table not found in active orders', 'error')
        return null
      }
      return { tableNumber: targetTable, orderGroupId: matchingOrder.id }
    }
  
    if (action === 'New Table') {
      if (!targetTable) {
        showToast('Please enter a new table number', 'error')
        return null
      }
      // Validate new table does not already exist
      const exists = pendingTables.value.some(t => String(t) === String(targetTable))
      if (exists) {
        showToast(`Table ${targetTable} already exists. Choose Merge instead.`, 'error')
        return null
      }
      return { tableNumber: targetTable, orderGroupId: `group-table-${targetTable}-${Date.now()}` }
    }
  
    showToast('Please select an action (Merge or New Table)', 'error')
    return null
  }
  
  async function rejectTransfer(transferIdString, reqId = null) {
    try {
      const response = await apiFetch(`/order-transfers/${transferIdString}/status`, {
        method: 'PATCH',
        body: JSON.stringify({ isAccepted: 2 })
      })
      if (response.ok) {
        showToast('Transfer rejected', 'info')
        if (reqId) {
          delete transferUIState.value[reqId]
        }
        await fetchTransferRequests()
      } else {
        showToast('Failed to reject transfer', 'error')
      }
    } catch (error) {
      console.error('Reject transfer failed:', error)
      showToast('Failed to reject transfer', 'error')
    }
  }
  
  watch(showTransferModal, (newVal) => {
    if (newVal) {
      fetchTransferRequests()
    } else {
      // Reset all UI states when closing
      transferUIState.value = {}
      transferRequests.value.forEach(req => {
        if (req.items) {
          req.items.forEach(item => { if (item.selected) item.selected = false })
        }
      })
    }
  })
  
  // currentUser moved to top
  function persistOrders() {
    localStorage.setItem('specialOrders', JSON.stringify(orders.value))
  }
  
  function syncExcludes() {
    billItems.value.forEach(item => {
      if (item.ingredients?.length) {
        item.excludeIngredients = item.ingredients.filter(ing => !ing.checked).map(ing => ing.name).join(', ')
      }
    })
  }
  
  function normalizeIngredientType(v) {
    const s = String(v || '').toLowerCase()
    if (s.includes('product')) return 'product'
    if (s.includes('item')) return 'item'
    return s
  }
  
  function buildOrderIngredientAndAmount(item) {
    const snapshot = item?.menu?.latestSavedMenuRecipe || null
    const raw = snapshot?.ingredient_and_amount ?? snapshot?.ingredientAndAmount ?? null
    if (!Array.isArray(raw)) return null
  
    const uncheckedKeys = new Set(
      Array.isArray(item?.ingredients)
        ? item.ingredients
            .filter(ing => ing && ing.checked === false)
            .map(ing => {
              const id = Number(ing.sourceId ?? ing.Id ?? ing.id)
              const t = normalizeIngredientType(ing.sourceType ?? ing.type)
              return Number.isFinite(id) ? `${t}:${id}` : null
            })
            .filter(Boolean)
        : []
    )
  
    const filtered = raw.filter(entry => {
      const id = Number(entry?.Id ?? entry?.id)
      const t = normalizeIngredientType(entry?.type)
      if (!Number.isFinite(id) || !t) return true
      return !uncheckedKeys.has(`${t}:${id}`)
    })
  
    // Return exactly as `{ Id, type, amount }`
    return filtered.map(entry => ({
      Id: Number(entry?.Id ?? entry?.id),
      type: entry?.type,
      amount: Number(entry?.amount),
    }))
  }
  
  onMounted(() => {
    // const saved = localStorage.getItem('specialOrders')
    // if (saved) orders.value = JSON.parse(saved)
  
    // Auto-fill waiter from logged-in user
    if (currentUser.value) {
      selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
    }
  
    // Pre-fetch orders to enable table number validation
    fetchOrders(false)
    loadWaiters()
    fetchTransferRequests()
    connectOrderSyncRealtime()
  
    // Periodic refresh for badges
    setInterval(fetchTransferRequests, 30000)
  })
  
  onUnmounted(() => {
    disconnectOrderSyncRealtime()
    cleanupPaymentTxnScan()
  })
  
  let orderSyncSocket = null
  let orderSyncReconnectTimer = null
  let orderSyncRefreshTimer = null
  
  function scheduleOrderSyncRefresh() {
    if (orderSyncRefreshTimer) clearTimeout(orderSyncRefreshTimer)
    orderSyncRefreshTimer = setTimeout(() => {
      orderSyncRefreshTimer = null
      // Keep current bill/edit view; only refresh live order lists quietly.
      fetchOrders(false)
      fetchTransferRequests()
    }, 300)
  }
  
  function disconnectOrderSyncRealtime() {
    if (orderSyncReconnectTimer) {
      clearTimeout(orderSyncReconnectTimer)
      orderSyncReconnectTimer = null
    }
    if (orderSyncRefreshTimer) {
      clearTimeout(orderSyncRefreshTimer)
      orderSyncRefreshTimer = null
    }
    if (orderSyncSocket) {
      try {
        orderSyncSocket.close()
      } catch (_) {
        // ignore close failures
      }
      orderSyncSocket = null
    }
  }
  
  function connectOrderSyncRealtime() {
    disconnectOrderSyncRealtime()
  
    const user = currentUser.value
    if (!user || typeof WebSocket === 'undefined') return
  
    const companyIdValue = user.companyId || user.company_id || user.company?.id
    if (!companyIdValue) return
  
    const branchIdValue = user.branchId || user.branch_id || user.branch?.id || null
    const socket = new WebSocket(WS_BASE_URL)
    orderSyncSocket = socket
  
    socket.addEventListener('open', () => {
      socket.send(JSON.stringify({
        type: 'frontend.subscribe',
        company_id: companyIdValue,
        branch_id: branchIdValue,
      }))
    })
  
    socket.addEventListener('message', (event) => {
      try {
        const message = JSON.parse(event.data)
        if (message.event?.startsWith('special_order_group.') || message.event?.startsWith('order_group.')) {
          scheduleOrderSyncRefresh()
        }
      } catch (_) {
        // ignore malformed realtime payloads
      }
    })
  
    socket.addEventListener('close', () => {
      orderSyncSocket = null
      orderSyncReconnectTimer = setTimeout(() => {
        connectOrderSyncRealtime()
      }, 3000)
    })
  }
  
  function handleOrdersButtonClick() {
    if (!canViewAllOrders.value) return
    ordersScheduleFilterDate.value = ''
    clearBillAreaOnly()
    fetchOrders()
  }

  function handleOrdersScheduleDateChange() {
    if (!canViewAllOrders.value) return
    if (!String(ordersScheduleFilterDate.value || '').trim()) {
      // Date cleared: keep same All-orders flow (unfiltered pending list)
      clearBillAreaOnly()
      fetchOrders()
      return
    }
    clearBillAreaOnly()
    fetchOrders()
  }

  async function fetchOrders(switchView = true) {
    if (switchView) {
      printFailures.value = []
    }
    try {
      const waiterIdParam = canViewAllOrders.value ? '' : (currentUser.value?.id || '')
      const scheduleDateParam = String(ordersScheduleFilterDate.value || '').trim()
      
      // Fetch only pending (isPaid=0) orders for the current user/waiter
      let query = `/special-orders?companyId=${companyId.value}&branchId=${branchId.value || ''}&waiterId=${waiterIdParam}&isPaid=0`
      if (scheduleDateParam) {
        query += `&scheduleDate=${encodeURIComponent(scheduleDateParam)}`
      }
      const response = await apiFetch(query)
      
      if (!response.ok) {
          console.error('Fetch orders failed:', response.statusText)
          showToast('Failed to fetch live orders.', 'error')
          orders.value = []
          if (switchView) viewMode.value = 'orders'
          return
      }
  
      const data = await response.json()
      
      // Safety check: ensure data is an array
      if (!Array.isArray(data)) {
        console.error('Expected array from fetchOrders, but got:', data)
        showToast('Live orders data is invalid.', 'error')
        orders.value = []
        if (switchView) viewMode.value = 'orders'
        return
      }
  
      // Group backend items by orderGroupId (bill)
      const groupsMap = {}
      data.forEach(item => {
        const gid = item.orderGroupId || item.createdAt || 'default'
        if (!groupsMap[gid]) {
          groupsMap[gid] = {
            id: gid,
            createdAt: item.createdAt,
            waiterName: item.waiterFullName || 'Unknown',
            waiterId: item.waiterId,
            table: item.tableNumber,
            isPaid: item.isPaid,
            isDelivery: !!item.deliveryId, // or item.isDelivery if it exists, but usually its by presence of deliveryId
            deliveryId: item.deliveryId,
            deliveryCompanyName: item.deliveryCompanyName || null,
            deliveryCode: item.deliveryCode,
            dailyOrderNo: item.dailyOrderNo,
            name: item.name || '',
            phone: item.phone || '',
            scheduleDate: item.scheduleDate || item.schedule_date || '',
            advancePayment: item.advancePayment ?? item.advance_payment ?? 0,
            grandTotal: item.grandTotal ?? item.grand_total ?? 0,
            paymentHistory: Array.isArray(item.paymentHistory) ? item.paymentHistory : [],
            itemImage: item.itemImage || item.item_image || null,
            remark: item.remark || null,
            isOpenPrice: item.isOpenPrice ?? item.is_open_price ?? 0,
            transferStatus: null, // 0: pending, 1: accepted
            hasPendingTransfer: false,
            isPrinted: 1, // Will be set to 0 if any item is 0
            items: []
          }
        }
  
        // DEBUG: console.log('Checking item print status:', item.id, item.isPrinted)
        if (item.isPrinted === 0) {
          groupsMap[gid].isPrinted = 0
          // console.log('Marking group as failed print:', gid)
        }
  
        // Track transfer status for the group
        if (item.transfers) {
          if (item.transfers.some(t => t.isAccepted === 0)) {
            groupsMap[gid].hasPendingTransfer = true
          }
          if (item.transfers.some(t => t.isAccepted === 0 && t.receiverId === currentUser.value?.id)) {
            groupsMap[gid].transferStatus = 0;
          } else if (item.transfers.some(t => t.isAccepted === 1 && t.receiverId === currentUser.value?.id)) {
            groupsMap[gid].transferStatus = 1;
          }
        }
  
        const displayItemName = item.itemName || item.menuName || item.menu?.name || 'Item'
        groupsMap[gid].items.push({
          itemId: item.id, // Database record ID
          updatedAt: item.updatedAt,
          menuId: item.menuId,
          menu: item.menu || { name: displayItemName, departmentId: null },
          itemName: displayItemName,
          name: displayItemName,
          qty: item.quantity,
          // Keep both legacy and DB-shaped fields available.
          // IMPORTANT: totals should use qty * unit_price (not "price").
          unitPrice: item.unitPrice ?? item.unit_price ?? item.unitPrice,
          unit_price: item.unit_price ?? item.unitPrice ?? item.unitPrice,
          isOpenPrice: item.isOpenPrice ?? item.is_open_price ?? 0,
          total_price: item.total_price ?? item.totalPrice ?? item.total_price,
          // Preserve the originally saved values; do NOT overwrite on confirm.
          price: item.price ?? item.unitPrice ?? item.unit_price ?? 0,
          addition: item.addition ?? 0,
          vat: item.vat ?? 0,
          excludeIngredients: item.excludeIngredients || '',
          note: item.note || '',
          isPrinted: item.isPrinted,
          notPrintedCount: item.not_printed_count || 0,
          transfers: item.transfers || []
        })
      })
      
      orders.value = Object.values(groupsMap).sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt))
      if (switchView) viewMode.value = 'orders'
    } catch (err) {
      console.error('Failed to fetch orders:', err)
      orders.value = []
      if (switchView) viewMode.value = 'orders'
    }
  }
  
  const sortedBillItems = computed(() => {
    const existingItems = billItems.value.filter(item => item.itemId || item.transferredItemId)
    const newItems = billItems.value.filter(item => !item.itemId && !item.transferredItemId)
  
    const sortedExisting = [...existingItems].sort((a, b) => {
      const nameA = (a.menu?.name || '').toLowerCase()
      const nameB = (b.menu?.name || '').toLowerCase()
      return nameA.localeCompare(nameB)
    })
  
    return [...newItems.reverse(), ...sortedExisting]
  })
  
  function selectDept(dept) {
    selectedDept.value = dept
    // When department is clicked, clear sub selection so we see ALL menus of that department
    selectedSub.value = null
  }
  
  function selectSub(sub) {
    selectedSub.value = sub
  }
  
  const filteredMenus = computed(() => {
    // 1. First, only consider menus that are active (status=1)
    const activeMenus = menus.value.filter(m => (m.status === 1 || m.status === undefined))
  
    // 2. If no department selected AND no search term, show nothing (welcome message)
    if (!selectedDept.value && !searchTerm.value) {
      return []
    }
  
    // 3. Apply search or category filters
    let result = []
    if (searchTerm.value) {
      // Search across all active menus
      const term = searchTerm.value.toLowerCase()
      result = activeMenus.filter(m => 
        m.name.toLowerCase().includes(term) || 
        (m.code && m.code.toLowerCase().includes(term))
      )
    } else if (selectedSub.value) {
      // Filter active menus by sub-department
      const subId = selectedSub.value.id
      result = activeMenus.filter(m => {
        const menuSubId = m.subDepartmentId ?? m.sub_department_id ?? m.subDeptId ?? m.sub_dept_id
        return menuSubId === subId
      })
    } else if (selectedDept.value) {
      // Filter active menus by department
      const deptId = selectedDept.value.id
      result = activeMenus.filter(m => {
        const menuDeptId = m.departmentId ?? m.department_id ?? m.deptId ?? m.dept_id
        return menuDeptId === deptId
      })
    }
  
    return result.slice().sort((a, b) =>
      (a.name || '').localeCompare(b.name || '', undefined, { sensitivity: 'base' })
    )
  })
  
  function addToBill(menu) {
    // Strict Ownership Check: Only the designated waiter can add items to an existing bill.
    if (currentEditingOrderId.value && !isOwnOrder.value) {
      showToast('You cannot add items to another waiter\'s order', 'error')
      return
    }

    // Selecting a menu item exits open-price mode (normal special order flow)
    if (isOpenPriceMode.value) {
      resetOpenPriceFields()
    }
  
    // Auto-switch to bill view
    viewMode.value = 'bill'
    printFailures.value = []
  
    // Merge ONLY with an existing 'new' item (unsaved, no database IDs)
    const existingNew = billItems.value.find(b => 
      !b.itemId && !b.transferredItemId &&
      b.menu.id === menu.id && 
      (b.note || '') === '' && 
      (b.excludeIngredients || '') === ''
    )
    if (existingNew) {
      existingNew.qty++
      existingNew.ownNotPrintedCount = (existingNew.ownNotPrintedCount || 0) + 1
      existingNew.notPrintedCount = (existingNew.notPrintedCount || 0) + 1
      existingNew.ownQty = (existingNew.ownQty || 0) + 1
      return
    }
    const recipeIngs = menu.recipes?.recipe_ingredients || []
    const activeIngs = recipeIngs.filter(ri => ri.is_active === 1).map(ri => ({
      id: ri.id,
      name: ri.items?.itemName || ri.item?.name || ri.products?.name || ri.product?.name || 'Unknown',
      checked: true
    }))
    billItems.value.push({ 
      localId: `local-${Date.now()}-${Math.floor(Math.random() * 1000)}`,
      menu, 
      qty: 1,
      originalQty: 0,
      orderId: null,
      orderNumber: null,
      excludeIngredients: '',
      ingredients: activeIngs,
      isExpanded: false,
      selected: false,
      note: '',
      transferredNotPrintedCount: 0,
      ownNotPrintedCount: 1,
      notPrintedCount: 1, // Truly new quantity
      isAcceptedTransfer: false,
      transferredItemId: undefined,
      transferredQty: 0,
      ownQty: 1
    })
  }
  
  async function removeFromBill(item) {
    if (!item) return
  
    const confirmMsg = `Are you sure you want to remove ${item.menu?.name || item.itemName || 'Item'}?`
    if (!window.confirm(confirmMsg)) return
  
    // Identify all saved item IDs (own and transferred)
    const idsToDelete = [item.itemId, item.transferredItemId].filter(Boolean)
  
    if (idsToDelete.length > 0) {
      if (!canVoidOrder.value) {
        showToast('You do not have privilege to remove saved items.', 'error')
        return
      }
      try {
        // Parallel deletion for all database records associated with this row
        await Promise.all(idsToDelete.map(id => 
          apiFetch(`/special-orders/${id}`, {
            method: 'DELETE',
            body: JSON.stringify({
              adminId: currentUser.value?.id,
              adminName: currentUser.value?.full_name || currentUser.value?.username || null
            })
          })
        ))
        showToast('Item removed successfully', 'success')
      } catch (err) {
        console.error('Failed to delete item:', err)
        const isSecurityLock = err.message && err.message.includes('System security lock')
        showToast(err.message || 'Failed to delete item.', 'error', isSecurityLock ? 10000 : 3000)
        return
      }
    }
  
    const idx = billItems.value.indexOf(item)
    if (idx !== -1) {
      billItems.value.splice(idx, 1)
    }
  
    // If the last item was removed, reset the bill state
    if (billItems.value.length === 0) {
      clearBill(true)
    }
  }
  
  async function changeQty(item, newQty) {
    if (!item) return
    if (newQty < 1) {
      showToast('Minimum quantity is 1. Please use the delete button to remove items.', 'error')
      return
    }
  
    const delta = newQty - item.qty
    const isExisting = !!(item.itemId || item.transferredItemId)
  
    if (delta > 0) {
      // Increase: Always adds to 'own' share
      item.qty = newQty
      item.ownQty = (item.ownQty || 0) + delta
      item.ownNotPrintedCount = (item.ownNotPrintedCount || 0) + delta
      item.notPrintedCount = (item.ownNotPrintedCount || 0) + (item.transferredNotPrintedCount || 0)
      return
    }
  
    // Decrease:
    if (isExisting) {
      if (!window.confirm(`Are you sure you want to decrease the quantity of ${item.menu?.name || item.itemName || 'Item'}?`)) return
    }
  
    try {
      const adminId = currentUser.value?.id
      const adminName = currentUser.value?.full_name || currentUser.value?.username || 'System'
  
      // Priority: Decrease from 'own' shares first
      if ((item.ownQty || 0) > 0) {
        const newOwnQty = item.ownQty - 1
        const newOwnNotPrintedCount = Math.max(0, (item.ownNotPrintedCount || 0) - 1)
  
        if (item.itemId) {
          await apiFetch(`/special-orders/${item.itemId}`, {
            method: 'PATCH',
            body: JSON.stringify({ 
              newQty: newOwnQty, 
              newNotPrintedCount: newOwnNotPrintedCount, 
              adminId, 
              adminName 
            })
          })
        }
        item.ownQty = newOwnQty
        item.ownNotPrintedCount = newOwnNotPrintedCount
          if (item.itemId)
        showToast('Quantity decreased from '+(item.menu?.name || item.itemName || 'Item'), 'success')
      } 
      // If own is exhausted, decrease from transferred share
      else if ((item.transferredQty || 0) > 1) {
        const newTransferredQty = item.transferredQty - 1
        const newTransferredNotPrintedCount = Math.max(0, (item.transferredNotPrintedCount || 0) - 1)
  
        if (item.transferredItemId) {
          await apiFetch(`/special-orders/${item.transferredItemId}`, {
            method: 'PATCH',
            body: JSON.stringify({ 
              newQty: newTransferredQty, 
              newNotPrintedCount: newTransferredNotPrintedCount, 
              adminId, 
              adminName 
            })
          })
        }
  
        item.transferredQty = newTransferredQty
        item.transferredNotPrintedCount = newTransferredNotPrintedCount
        showToast('Quantity decreased from transferred share', 'success')
      }
  
      // Sync total counts
      item.qty = newQty
      item.notPrintedCount = (item.ownNotPrintedCount || 0) + (item.transferredNotPrintedCount || 0)
  
    } catch (err) {
      console.error('Failed to update quantity:', err)
      const isSecurityLock = err.message && err.message.includes('System security lock')
      showToast(err.message || 'Failed to update quantity.', 'error', isSecurityLock ? 10000 : 3000)
      // Optionally: fetchOrders() here to resync UI with database if something went wrong
    }
  }
  
  
  function toggleExpansion(item) {
    const targetState = !item.isExpanded
    if (targetState) {
      billItems.value.forEach(i => { i.isExpanded = false })
    }
    item.isExpanded = targetState
  }
  
  function appendTableNumber(digit) {
    tableNumber.value += digit.toString()
    tableError.value = false
  }
  
  async function clearBill(skipConfirm = false) {
    // strictly check skipConfirm is not true/truthy event
    if (skipConfirm !== true && billItems.value.length > 0) {
      const isActuallyEditing = currentEditingOrderId.value && currentEditingOrderId.value !== 'null'
      const msg = isActuallyEditing
        ? "Are you sure you want to DELETE this entire order from the database?" 
        : "Are you sure you want to clear the current bill?"
      
      if (!window.confirm(msg)) return
  
      if (isActuallyEditing) {
        if (!canVoidOrder.value) {
          showToast('You do not have privilege to delete this order.', 'error')
          return
        }
        try {
          await apiFetch(`/special-orders/group/${currentEditingOrderId.value}`, {
            method: 'DELETE',
            body: JSON.stringify({
              adminId: currentUser.value?.id,
              adminName: currentUser.value?.full_name || currentUser.value?.username || null
            })
          })
          // Remove from local orders list for immediate UI update
          if (Array.isArray(orders.value)) {
            orders.value = orders.value.filter(o => 
              o.id !== currentEditingOrderId.value && 
              o.orderGroupId !== currentEditingOrderId.value &&
              o.createdAt !== currentEditingOrderId.value
            )
          }
          showToast('Order deleted successfully', 'success')
        } catch (err) {
          console.error('Failed to delete order group:', err)
          const isSecurityLock = err.message && err.message.includes('System security lock')
          showToast(err.message || 'Failed to delete order.', 'error', isSecurityLock ? 10000 : 3000)
        }
      }
    }
  
    const billWasEmpty = billItems.value.length === 0
    billItems.value = []
    
    if (!skipConfirm || billWasEmpty) {
      printFailures.value = []
    }
  
    tableNumber.value = ''
    tableError.value = false
    currentEditingOrderId.value = null
    originalWaiterId.value = null
    selectedOrderDate.value = ''
    isDelivery.value = false
    deliveryCompany.value = ''
    deliveryCode.value = ''
    specialOrderName.value = ''
    specialOrderPhone.value = ''
    specialOrderScheduleDate.value = ''
    resetSpecialOrderExtraFields()
    showPaymentModal.value = false
    paymentPhase.value = 'selection'
    selectedPaymentMethod.value = null
    customerPhone.value = ''
    // Keep waiter as the logged-in user
    if (currentUser.value) {
      selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
    }
  }
  
  function clearBillAreaOnly() {
    // Clear UI only: no API calls, no logs, no confirmations.
    billItems.value = []
    printFailures.value = []
  
    tableNumber.value = ''
    tableError.value = false
  
    currentEditingOrderId.value = null
    originalWaiterId.value = null
    selectedOrderDate.value = ''
  
    isDelivery.value = false
    deliveryCompany.value = ''
    deliveryCode.value = ''

    specialOrderName.value = ''
    specialOrderPhone.value = ''
    specialOrderScheduleDate.value = ''
    resetSpecialOrderExtraFields()
  
    showPaymentModal.value = false
    paymentPhase.value = 'selection'
    selectedPaymentMethod.value = null
    customerPhone.value = ''
  
    // Keep waiter as the logged-in user
    if (currentUser.value) {
      selectedWaiter.value = currentUser.value.full_name || currentUser.value.username || ''
    }
  }
  
  function handleBackOrClear() {
    // Back while editing should only clear the bill area (no DB delete, no log, no confirm)
    if (currentEditingOrderId.value && currentEditingOrderId.value !== 'null') {
      clearBillAreaOnly()
      return
    }
    // Skip confirmation for simply clearing an unsaved bill
    clearBill(true)
  }
  
  // getMergedItems is no longer needed as we support individual rows
  
  function resolveOrderTableNumber() {
    const trimmedTable = String(tableNumber.value ?? '').trim()
    if (trimmedTable) return trimmedTable
    if (isDelivery.value) {
      const code = String(deliveryCode.value ?? '').trim()
      if (code) return `Code-${code}`
    }
    if (isTableMandatory.value === 0) {
      return Date.now().toString()
    }
    return ''
  }
  
  async function sendOrder(options = {}) {
    if (isSending.value) return

    const confirmPaid = options === true
      || options?.confirmPaid === true
      || options?.confirmPaid === 1

    const openPriceName = String(openPriceItemName.value || '').trim()
    const openPriceQtyNum = Number(openPriceQty.value) || 0
    const openPriceUnitNum = Number(openPriceUnitPrice.value) || 0

    if (isOpenPriceMode.value) {
      if (!openPriceName || !(openPriceQtyNum > 0) || !(openPriceUnitNum > 0)) {
        showToast('Please enter Item Name, Quantity and Unit Price.', 'error')
        return
      }
    } else if (billItems.value.length === 0) {
      return
    }

    const remainingNum = Number(specialOrderRemaining.value)
    if (remainingNum < 0) {
      showToast('Remaining cannot be negative. Payment exceeds grand total.', 'error')
      return
    }
    if (confirmPaid && remainingNum !== 0) {
      showToast('Remaining must be 0 to confirm payment.', 'error')
      return
    }

    const advanceNum = Number(specialOrderAdvancePayment.value) || 0
    if (advanceNum > 0 && !String(specialOrderPaymentType.value || '').trim()) {
      showToast('Please select Payment Type for the advance payment.', 'error')
      return
    }
    if (advanceNum > 0 && showSpecialOrderRefNumber.value && !String(specialOrderRefNumber.value || '').trim()) {
      showToast('Please enter Ref Number for this payment method.', 'error')
      return
    }

    isSending.value = true
    printFailures.value = []
    try {
    if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
      tableError.value = true
      return
    }
    tableError.value = false
    syncExcludes()
    
    const orderGroupId = currentEditingOrderId.value || `spo-${Date.now()}-${Math.floor(Math.random() * 1000)}`
  
    if (isDelivery.value && (!deliveryCompany.value || !deliveryCode.value)) {
      showToast('Please select delivery company and enter code.', 'error')
      isSending.value = false
      return
    }
  
    const resolvedTableNumber = resolveOrderTableNumber()
  
    // TABLE VALIDATION: Check if table number already exists in pending (for this waiter)
    if (!isDelivery.value && !currentEditingOrderId.value && tableNumber.value) {
      const todayDate = new Date().toISOString().split('T')[0] // YYYY-MM-DD
      const tableExists = orders.value.some(o => 
        o.isPaid !== 1 && 
        String(o.table) === String(tableNumber.value) &&
        String(o.waiterId) === String(currentUser.value?.id) &&
        (o.createdAt ? String(o.createdAt).split('T')[0] : '') === todayDate &&
        String(o.id) !== String(currentEditingOrderId.value)
      )
      if (tableExists) {
        showToast('Table number already exists in pending.', 'error')
        isSending.value = false
        tableNumber.value=""
        return
      }
    }
  
    const itemsToSave = []
    if (isOpenPriceMode.value) {
      const existing = billItems.value[0] || null
      const qty = openPriceQtyNum
      const unitPrice = openPriceUnitNum
      itemsToSave.push({
        menuId: null,
        itemName: openPriceName,
        itemId: existing?.itemId || null,
        companyId: companyId.value,
        branchId: branchId.value,
        waiterId: currentEditingOrderId.value ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || null),
        tableNumber: resolvedTableNumber,
        unitPrice,
        price: unitPrice,
        addition: 0,
        vat: 0,
        quantity: qty,
        totalPrice: qty * unitPrice,
        excludeIngredients: existing?.excludeIngredients || null,
        note: existing?.note || null,
        ingredient_and_amount: null,
        isPaid: 0,
        orderGroupId: orderGroupId,
        deliveryId: isDelivery.value ? String(deliveryCompany.value) : null,
        deliveryCode: isDelivery.value ? deliveryCode.value : null,
        companyName: companyName.value || null,
        printerIP: null,
        departmentName: 'Open Price',
        departmentId: null,
        howManyCopies: 1,
        isForStaff: 'Special',
        isAcceptedTransfer: 0,
        not_printed_count: existing?.ownNotPrintedCount || existing?.notPrintedCount || 0
      })
    } else {
      billItems.value.forEach(item => {
        const deptId = item.menu.departmentId ?? item.menu.department_id ?? item.menu.deptId ?? item.menu.dept_id;
        const dept = departments.value.find(d => d.id === deptId);
        const printerIP = dept ? dept.printerIP : null;
        const departmentName = dept ? dept.name : 'Unknown Department';
        const howManyCopies = dept ? (Number(dept.how_many_copies ?? dept.howManyCopies ?? 1) || 1) : 1;
    
        const baseItem = {
          menuId: item.menu.id,
          itemName: item.menu?.name || item.itemName || null,
          companyId: companyId.value,
          branchId: branchId.value,
          waiterId: currentEditingOrderId.value ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || null),
          tableNumber: resolvedTableNumber,
          unitPrice: item.menu.totalPrice,
          // Preserve the originally created values; never overwrite with zeros.
          price: Number(item.menu.price ?? item.price ?? 0) || 0,
          addition: Number(item.menu.addition ?? item.addition ?? 0) || 0,
          vat: Number(item.menu.vat ?? item.vat ?? 0) || 0,
          excludeIngredients: item.excludeIngredients,
          note: item.note,
          ingredient_and_amount: buildOrderIngredientAndAmount(item),
          isPaid: 0,
          orderGroupId: orderGroupId,
          deliveryId: isDelivery.value ? String(deliveryCompany.value) : null,
          deliveryCode: isDelivery.value ? deliveryCode.value : null,
          companyName: companyName.value || null,
          printerIP: printerIP,
          departmentName: departmentName,
          departmentId: deptId ?? null,
          howManyCopies: howManyCopies,
          isForStaff: 'Special'
        }
    
        if (item.transferredQty > 0) {
          itemsToSave.push({ 
            ...baseItem, 
            itemId: item.transferredItemId || null,
            quantity: item.transferredQty, 
            totalPrice: item.transferredQty * item.menu.totalPrice,
            isAcceptedTransfer: 1,
            not_printed_count: item.transferredNotPrintedCount || 0
          })
        }
        if (item.ownQty > 0) {
          itemsToSave.push({ 
            ...baseItem, 
            itemId: item.itemId || null,
            waiterId: item.itemId ? (originalWaiterId.value || currentUser.value?.id) : (currentUser.value?.id || originalWaiterId.value || null),
            quantity: item.ownQty, 
            totalPrice: item.ownQty * item.menu.totalPrice,
            isAcceptedTransfer: 0,
            not_printed_count: item.ownNotPrintedCount || 0
          })
        }
      })
    }

    const payloadGrandTotal = Number(specialOrderGrandTotalNumber.value) || 0
  
    try {
      const rawResponse = await apiFetch('/special-orders', {
        method: 'POST',
        body: JSON.stringify({
          name: specialOrderName.value || null,
          phone: specialOrderPhone.value || null,
          scheduleDate: specialOrderScheduleDate.value || null,
          advancePayment: advanceNum,
          paymentType: specialOrderPaymentType.value || null,
          paymentMethod: specialOrderPaymentType.value || null,
          refNumber: showSpecialOrderRefNumber.value ? (specialOrderRefNumber.value || null) : null,
          paymentDate: new Date().toISOString(),
          waiterId: currentUser.value?.id || currentUser.value?.sub || null,
          itemImage: specialOrderItemImage.value || '',
          remark: specialOrderRemark.value || null,
          isOpenPrice: isOpenPriceMode.value ? 1 : 0,
          grandTotal: payloadGrandTotal,
          confirmPaid: confirmPaid ? 1 : 0,
          items: itemsToSave,
        }),
      })
      if (!rawResponse.ok) {
        const errorData = await rawResponse.json().catch(() => ({}))
        throw new Error(errorData.message || 'Server error')
      }
      const response = await rawResponse.json().catch(() => ({}))
  
      if (response && response.printFailures && response.printFailures.length > 0) {
        printFailures.value = response.printFailures
        showToast(response.message || `Printing failed for: ${response.printFailures.join(', ')}`, 'error')
        await fetchOrders(false)
        const reloadId = currentEditingOrderId.value || orderGroupId
        if (!currentEditingOrderId.value) {
          currentEditingOrderId.value = reloadId
        }
        viewOrder(reloadId)
        billItems.value = billItems.value.filter(item =>
          (Number(item.notPrintedCount) || 0) > 0
          || (Number(item.ownNotPrintedCount) || 0) > 0
          || (Number(item.transferredNotPrintedCount) || 0) > 0
        )
        return
      }
  
      showToast(
        confirmPaid
          ? 'Order confirmed successfully'
          : (currentEditingOrderId.value ? 'Order updated successfully' : 'Order sent successfully'),
        'success'
      )
    } catch (err) { 
      console.error('DB Persistence Failed', err) 
      const isSecurityLock = err.message && err.message.includes('Date and time issue')
      showToast(err.message || 'Failed to save order.', 'error', isSecurityLock ? 60000 : 3000)
      return
    }
  
    if (currentEditingOrderId.value) {
      const idx = orders.value.findIndex(o => o.id === currentEditingOrderId.value)
      if (idx !== -1) {
        orders.value[idx].items = billItems.value
        orders.value[idx].table = resolvedTableNumber
        orders.value[idx].isDelivery = isDelivery.value
        orders.value[idx].deliveryId = isDelivery.value ? String(deliveryCompany.value) : null
        orders.value[idx].deliveryCode = isDelivery.value ? deliveryCode.value : null
        orders.value[idx].name = specialOrderName.value || ''
        orders.value[idx].phone = specialOrderPhone.value || ''
        orders.value[idx].scheduleDate = specialOrderScheduleDate.value || ''
        orders.value[idx].advancePayment = (sumPaymentHistoryAmount(specialOrderPaymentHistory.value) + advanceNum)
        orders.value[idx].paymentHistory = [
          ...specialOrderPaymentHistory.value,
          ...(advanceNum > 0 ? [buildLocalPaymentEntry(advanceNum)] : []),
        ]
        orders.value[idx].itemImage = specialOrderItemImage.value || null
        orders.value[idx].remark = specialOrderRemark.value || null
        orders.value[idx].isOpenPrice = isOpenPriceMode.value ? 1 : 0
        orders.value[idx].grandTotal = payloadGrandTotal
        if (confirmPaid && remainingNum === 0) {
          orders.value[idx].isPaid = 1
        }
        if (isOpenPriceMode.value) {
          orders.value[idx].items = [{
            itemId: billItems.value[0]?.itemId || null,
            menuId: null,
            menu: { name: openPriceName, totalPrice: openPriceUnitNum, price: openPriceUnitNum, addition: 0, vat: 0 },
            itemName: openPriceName,
            name: openPriceName,
            qty: openPriceQtyNum,
            unitPrice: openPriceUnitNum,
            unit_price: openPriceUnitNum,
            price: openPriceUnitNum,
            addition: 0,
            vat: 0,
          }]
        }
      }
    } else {
      const orderId = orderGroupId
      const orderNumber = orders.value.length + 1
      const openPriceLocalItems = isOpenPriceMode.value
        ? [{
            itemId: null,
            menuId: null,
            menu: { name: openPriceName, totalPrice: openPriceUnitNum, price: openPriceUnitNum, addition: 0, vat: 0 },
            itemName: openPriceName,
            name: openPriceName,
            qty: openPriceQtyNum,
            unitPrice: openPriceUnitNum,
            unit_price: openPriceUnitNum,
            price: openPriceUnitNum,
            addition: 0,
            vat: 0,
          }]
        : billItems.value
      orders.value.push({
        id: orderId,
        orderNumber: orderNumber,
        createdAt: new Date().toISOString(),
        waiterName: selectedWaiter.value,
        waiterId: currentUser.value?.id,
        table: resolvedTableNumber,
        isPaid: confirmPaid && remainingNum === 0 ? 1 : 0,
        isDelivery: isDelivery.value,
        deliveryId: isDelivery.value ? String(deliveryCompany.value) : null,
        deliveryCode: isDelivery.value ? deliveryCode.value : null,
        name: specialOrderName.value || '',
        phone: specialOrderPhone.value || '',
        scheduleDate: specialOrderScheduleDate.value || '',
        advancePayment: advanceNum,
        paymentHistory: advanceNum > 0 ? [buildLocalPaymentEntry(advanceNum)] : [],
        itemImage: specialOrderItemImage.value || null,
        remark: specialOrderRemark.value || null,
        isOpenPrice: isOpenPriceMode.value ? 1 : 0,
        grandTotal: payloadGrandTotal,
        items: openPriceLocalItems,
        orderGroupId: orderGroupId,
        note: openPriceLocalItems.map(item => item.note).filter(Boolean).join(', '),
        tableNumber: resolvedTableNumber,
      })
    }
    
    const printSnapshot = buildSpecialOrderBillPrintSnapshot({
      orderGroupId,
      advanceNum,
      payloadGrandTotal,
      remainingNum,
      openPriceName,
      openPriceQtyNum,
      openPriceUnitNum,
    })

    persistOrders()
    clearBill(true)
    await fetchOrders(false)

    setTimeout(async () => {
      if (confirm('Are you sure..........Print?')) {
        await generateSpecialOrderBillPdf(printSnapshot)
      }
    }, 150)
    } finally {
      isSending.value = false
    }
  }
  
  
  function handlePaymentSelection(method) {
    selectedPaymentMethod.value = method
    const isCash = method.name?.toLowerCase() === 'cash' || method.name?.toLowerCase() === 'delivery'
    
    if (isCash) {
      markPaid(method)
    } else {
      paymentPhase.value = 'details'
    }
  }
  
  async function markPaid(paymentMethod = 'Cash') {
    if (billItems.value.length === 0 || isSending.value) return
    isSending.value = true
    try {
      if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
        tableError.value = true
        return
      }
      tableError.value = false
    syncExcludes()
    
    if (isDelivery.value && (!deliveryCompany.value || !deliveryCode.value)) {
      showToast('Please select delivery company and enter code.', 'error')
      isSending.value = false
      return
    }
  
    const methodObj = typeof paymentMethod === 'string' ? { name: paymentMethod } : paymentMethod
    const isCash = methodObj.name?.toLowerCase() === 'cash' || methodObj.name?.toLowerCase() === 'delivery'
    const methodName = methodObj.name || 'Cash'
    const paymentMethodToSave = isCash ? methodName : `${methodName}, ${customerPhone.value}`
    
    // Simulation Logic for Phone-based payments
    const isPhonePayment = paymentMethod && !isCash
    
    if (isPhonePayment) {
      isProcessingPayment.value = true
      paymentSimulationStatus.value = 'waiting'
      // Wait for 20 seconds
      await new Promise(resolve => setTimeout(resolve, 20000))
      
      paymentSimulationStatus.value = 'success'
      // Wait for 10 seconds
      await new Promise(resolve => setTimeout(resolve, 10000))
      
      isProcessingPayment.value = false
    }
  
    const orderGroupId = currentEditingOrderId.value
    if (!orderGroupId || orderGroupId === 'null') {
      showToast('Open an existing order from the list before confirming payment.', 'error')
      return
    }
  
    try {
      const rawResponse = await apiFetch(`/special-orders/group/${encodeURIComponent(orderGroupId)}/confirm`, {
        method: 'PATCH',
        body: JSON.stringify({
          paymentMethod: paymentMethodToSave,
          paymentType: specialOrderPaymentType.value || null,
          refNumber: showSpecialOrderRefNumber.value ? (specialOrderRefNumber.value || null) : null,
          deliveryId: isDelivery.value ? String(deliveryCompany.value) : null,
          deliveryCode: isDelivery.value ? deliveryCode.value : null,
          companyId: companyId.value,
          branchId: branchId.value,
        }),
      })
      if (!rawResponse.ok) {
        const errorData = await rawResponse.json().catch(() => ({}))
        throw new Error(errorData.message || 'Server error')
      }
  
      showToast('Payment processed successfully', 'success')
    } catch (err) { 
      console.error('DB Persistence Failed', err)
      const isSecurityLock = err.message && err.message.includes('System security lock')
      showToast(err.message || 'Failed to process payment.', 'error', isSecurityLock ? 10000 : 3000)
      return
    }
  
    const idx = orders.value.findIndex(o => o.id === orderGroupId)
    if (idx !== -1) {
      orders.value[idx].items = billItems.value
      orders.value[idx].isPaid = 1
      orders.value[idx].paymentMethod = paymentMethodToSave
      orders.value[idx].customerPhone = customerPhone.value
      orders.value[idx].deliveryId = isDelivery.value ? String(deliveryCompany.value) : null
      orders.value[idx].deliveryCode = isDelivery.value ? deliveryCode.value : null
      persistOrders()
    }
  
    clearBill(true)
    await fetchOrders(false)
    } finally {
      isSending.value = false
    }
  }
  
  function confirmBill() {
    if (billItems.value.length === 0) return
    if (!canConfirmOrder.value) {
      showToast('You do not have privilege to confirm orders.', 'error')
      return
    }
    // if (!canClickConfirmBill.value) return
    if (isTableMandatory.value === 1 && !tableNumber.value && !isDelivery.value) {
      tableError.value = true
      return
    }
  
   if( currentEditingOrderId.value!==null && currentEditingOrderId.value!=="null")
    showPaymentModal.value = true
  }

  /** Same as Send/Update (validate + save), and marks is_paid=1 when remaining is 0. */
  async function confirmOrder() {
    if (!canConfirmOrder.value) {
      showToast('You do not have privilege to confirm special orders.', 'error')
      return
    }
    return sendOrder({ confirmPaid: true })
  }
  
  
  function getBillItemAmountParts(b) {
    const toNum = (v) => {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    }
    const qty = toNum(b?.qty ?? b?.quantity)
    const unitPrice = toNum(b?.menu?.price ?? b?.price ?? 0)
    const unitAddition = toNum(b?.menu?.addition ?? b?.addition ?? 0)
    const unitVat = toNum(b?.menu?.vat ?? b?.vat ?? 0)
    const unitTotal = toNum(
      b?.menu?.totalPrice ??
      b?.menu?.total_price ??
      b?.unit_price ??
      b?.unitPrice ??
      b?.totalPrice ??
      b?.total_price
    )
    return {
      base: unitPrice * qty,
      addition: unitAddition * qty,
      vat: unitVat * qty,
      grand: unitTotal * qty
    }
  }
  
  const billAmountSummary = computed(() => {
    const totals = billItems.value.reduce(
      (acc, item) => {
        const parts = getBillItemAmountParts(item)
        acc.baseAmt += parts.base
        acc.additionalAmt += parts.addition
        acc.taxAmt += parts.vat
        acc.grandTotal += parts.grand
        return acc
      },
      { baseAmt: 0, additionalAmt: 0, taxAmt: 0, grandTotal: 0 }
    )
    return {
      baseAmt: totals.baseAmt.toFixed(2),
      additionalAmt: totals.additionalAmt.toFixed(2),
      taxAmt: totals.taxAmt.toFixed(2),
      grandTotal: totals.grandTotal.toFixed(2)
    }
  })
  
  const totalPrice = computed(() => billAmountSummary.value.grandTotal)

  const specialOrderGrandTotalNumber = computed(() => {
    if (isOpenPriceMode.value) {
      const qty = Number(openPriceQty.value) || 0
      const unit = Number(openPriceUnitPrice.value) || 0
      const fromFields = qty * unit
      if (fromFields > 0 || String(openPriceItemName.value || '').trim()) return fromFields
    }
    const fromBill = Number(billAmountSummary.value.grandTotal) || 0
    if (fromBill > 0) return fromBill
    const editing = orders.value.find(o => o.id === currentEditingOrderId.value)
    return Number(editing?.grandTotal) || 0
  })

  const specialOrderRemaining = computed(() => {
    const grand = specialOrderGrandTotalNumber.value
    const historyPaid = sumPaymentHistoryAmount(specialOrderPaymentHistory.value)
    const advance = Number(specialOrderAdvancePayment.value) || 0
    return (grand - historyPaid - advance).toFixed(2)
  })

  const specialOrderPaidSoFar = computed(() => {
    return sumPaymentHistoryAmount(specialOrderPaymentHistory.value)
  })
  
  const orderGroups = computed(() => {
    const groupsMap = {}
    if (!Array.isArray(orders.value)) return []
  
    const uid = currentUser.value?.id || currentUser.value?.sub
    orders.value.filter(o => o && o.isPaid !== 1 && (o.transferStatus !== 0 || String(o.waiterId) === String(uid))).forEach(o => {
      const key = o.id || o.createdAt || Math.random().toString()
      if (!groupsMap[key]) {
        const wName = o.waiterName || o.waiter || ''
        const firstName = wName.split(' ')[0]
        groupsMap[key] = { 
          ...o, 
          waiterName: firstName || 'System',
          totalPriceSum: 0 
        }
      }
      if (Array.isArray(o.items)) {
        const priceSum = o.items.reduce((a, i) => a + (Number(i.qty) || 0) * (Number(i.unitPrice) || 0), 0)
        groupsMap[key].totalPriceSum += priceSum
        
        // Check if any item in this group has unprinted quantity
        const hasUnprinted = o.items.some(i => (Number(i.not_printed_count || i.notPrintedCount) || 0) > 0)
        if (hasUnprinted) {
          groupsMap[key].isAnyUnprinted = true
        }
      }
    })
    return Object.values(groupsMap).sort((a,b) => new Date(a.createdAt) - new Date(b.createdAt))
  })
  
  const todayOrders = computed(() => {
    const today = new Date().toISOString().split('T')[0]
    const filtered = orderGroups.value.filter(o => {
      const orderDate = o.createdAt ? String(o.createdAt).split('T')[0] : ''
      return orderDate === today
    })
  
    // Deduplicate by (waiterId + table) for the "All orders" list.
    // Prefer accepted/merged groups (transferStatus === 1) when duplicates exist.
    const byKey = new Map()
    filtered.forEach(o => {
      const k = `${String(o.waiterId ?? '')}|${String(o.table ?? '')}`
      const prev = byKey.get(k)
      if (!prev) {
        byKey.set(k, o)
        return
      }
      const prevAccepted = prev.transferStatus === 1
      const oAccepted = o.transferStatus === 1
      if (oAccepted && !prevAccepted) {
        byKey.set(k, o)
        return
      }
      // If both are accepted (or both not accepted), keep the latest by createdAt.
      const prevTime = prev.createdAt ? new Date(prev.createdAt).getTime() : 0
      const oTime = o.createdAt ? new Date(o.createdAt).getTime() : 0
      if (oTime > prevTime) byKey.set(k, o)
    })
  
    return Array.from(byKey.values()).sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
  })
  
  const beforeTodayOrders = computed(() => {
    const today = new Date().toISOString().split('T')[0]
    const filtered = orderGroups.value.filter(o => {
      const orderDate = o.createdAt ? String(o.createdAt).split('T')[0] : ''
      return orderDate && orderDate < today
    })
  
    // Same dedupe rule for the "Before Today Orders" list.
    const byKey = new Map()
    filtered.forEach(o => {
      const k = `${String(o.waiterId ?? '')}|${String(o.table ?? '')}|${o.createdAt ? String(o.createdAt).split('T')[0] : ''}`
      const prev = byKey.get(k)
      if (!prev) {
        byKey.set(k, o)
        return
      }
      const prevAccepted = prev.transferStatus === 1
      const oAccepted = o.transferStatus === 1
      if (oAccepted && !prevAccepted) {
        byKey.set(k, o)
        return
      }
      const prevTime = prev.createdAt ? new Date(prev.createdAt).getTime() : 0
      const oTime = o.createdAt ? new Date(o.createdAt).getTime() : 0
      if (oTime > prevTime) byKey.set(k, o)
    })
  
    // Most recent from previous days first
    return Array.from(byKey.values()).sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
  })
  
  // async function handlePageRefresh() {
  //   try {
  //     showToast('Refreshing page...', 'success')
  //     await Promise.all([
  //       loadDepartments(),
  //       loadMenus(),
  //       loadPaymentMethods(),
  //       loadDeliveryCompanies(),
  //       fetchOrders(false),
  //       loadWaiters(),
  //       fetchTransferRequests()
  //     ])
  //     clearBill(true)
  //   } catch (err) {
  //     console.error('Refresh failed', err)
  //     showToast('Failed to refresh page', 'error')
  //   }
  // }
  
  function viewOrder(orderId) {
    const o = orders.value.find(x => (x.id === orderId) || (x.createdAt === orderId))
    if (!o) return
    currentEditingOrderId.value = o.id
    originalWaiterId.value = o.waiterId || null
    
    const displayedItems = []
    o.items.forEach(i => {
      const isAccepted = Array.isArray(i.transfers) && i.transfers.some(t => t.isAccepted === 1 && t.receiverId === currentUser.value?.id)
      const iMenuId = i.menuId != null && i.menuId !== '' ? String(i.menuId) : ''
      const menuObj = iMenuId ? menus.value.find(m => String(m.id ?? '') === iMenuId) : null
      const displayName = i.itemName || i.name || menuObj?.name || i.menu?.name || 'Open Price'
      const excludeKey = String(i.excludeIngredients || '')
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .join(',')
      const noteKey = String(i.note || '').trim()
      const mergeKey = iMenuId || `open:${displayName}`
      
      // Merge identical database items for display
      const existing = displayedItems.find(mi => {
        const miMenuId = mi.menu?.id != null && mi.menu?.id !== '' ? String(mi.menu.id) : ''
        const miKey = miMenuId || `open:${mi.menu?.name || mi.itemName || ''}`
        return miKey === mergeKey &&
          String(mi.excludeIngredients || '')
            .split(',')
            .map(s => s.trim())
            .filter(Boolean)
            .join(',') === excludeKey &&
          String(mi.note || '').trim() === noteKey
      })
      
      if (existing) {
        const qtyToAdd = Number(i.quantity ?? i.qty ?? 0) || 0
        const npToAdd = (i.not_printed_count || i.notPrintedCount || 0)
        existing.qty += qtyToAdd
        if (isAccepted) {
          existing.transferredQty += qtyToAdd
          existing.transferredNotPrintedCount += npToAdd
          existing.transferredItemId = i.id || i.itemId
        } else {
          existing.ownQty += qtyToAdd
          existing.ownNotPrintedCount += npToAdd
          existing.itemId = i.id || i.itemId
        }
        existing.notPrintedCount += npToAdd
      } else {
        const recipeIngs = menuObj?.recipes?.recipe_ingredients || []
        const excludedList = (i.excludeIngredients || '').split(',').map(s => s.trim()).filter(Boolean)
        const activeIngs = recipeIngs.filter(ri => ri.is_active === 1).map(ri => {
          const name = ri.items?.itemName || ri.item?.name || ri.products?.name || ri.product?.name || 'Unknown'
          return { id: ri.id, name, checked: !excludedList.includes(name) }
        })
        const unitPrice = Number(i.unit_price ?? i.unitPrice ?? 0) || 0
        const savedPrice = Number(i.price ?? 0) || 0
        const savedAddition = Number(i.addition ?? 0) || 0
        const savedVat = Number(i.vat ?? 0) || 0
  
        displayedItems.push({
          localId: `load-${i.id || i.itemId || Math.random()}`,
          itemId: isAccepted ? undefined : (i.id || i.itemId),
          transferredItemId: isAccepted ? (i.id || i.itemId) : undefined,
          itemName: displayName,
          menu: {
            ...(menuObj || i.menu || {}),
            id: i.menuId ?? null,
            name: displayName,
            totalPrice: unitPrice,
            price: savedPrice || unitPrice,
            addition: savedAddition,
            vat: savedVat
          },
          unitPrice,
          unit_price: unitPrice,
          qty: Number(i.quantity ?? i.qty ?? 0) || 0,
          transferredQty: isAccepted ? (i.quantity || i.qty) : 0,
          ownQty: isAccepted ? 0 : (i.quantity || i.qty),
          isAcceptedTransfer: isAccepted,
          originalQty: i.quantity || i.qty,
          orderId: o.id,
          orderNumber: o.orderNumber,
          excludeIngredients: i.excludeIngredients || '',
          ingredients: activeIngs,
          isExpanded: false,
          selected: false,
          note: i.note || '',
          transferredNotPrintedCount: isAccepted ? (i.not_printed_count || i.notPrintedCount || 0) : 0,
          ownNotPrintedCount: isAccepted ? 0 : (i.not_printed_count || i.notPrintedCount || 0),
          notPrintedCount: i.not_printed_count || i.notPrintedCount || 0
        })
      }
    })
    billItems.value = displayedItems
    
    tableNumber.value = o.table ? String(o.table) : ''
    selectedWaiter.value = o.waiterName || o.waiter || ''
    isDelivery.value = !!o.isDelivery || o.table === 'Delivery'
    deliveryCompany.value = resolveDeliveryCompanySelection(o.deliveryId || o.deliveryCompany || o.deliveryCompanyName || '')
    deliveryCode.value = o.deliveryCode || ''
    specialOrderName.value = o.name || ''
    specialOrderPhone.value = o.phone || ''
    specialOrderScheduleDate.value = o.scheduleDate || ''
    // Existing paid history is kept for Remaining; new payment inputs stay empty
    specialOrderPaymentHistory.value = Array.isArray(o.paymentHistory) ? [...o.paymentHistory] : []
    specialOrderItemImage.value = o.itemImage || ''
    specialOrderRemark.value = o.remark || ''
    resetSpecialOrderPaymentInputs()

    const openPriceFlag = Number(o.isOpenPrice) === 1
      || (Array.isArray(o.items) && o.items.some(it => (it.menuId == null || it.menuId === '') && (it.itemName || it.name)))
    isOpenPriceMode.value = !!openPriceFlag
    if (isOpenPriceMode.value && displayedItems[0]) {
      openPriceItemName.value = displayedItems[0].itemName || displayedItems[0].menu?.name || ''
      openPriceQty.value = Number(displayedItems[0].qty) || 0
      openPriceUnitPrice.value = Number(displayedItems[0].unitPrice || displayedItems[0].menu?.totalPrice) || 0
    } else {
      openPriceItemName.value = ''
      openPriceQty.value = ''
      openPriceUnitPrice.value = ''
    }

    if (o.createdAt) {
      const datePart = o.createdAt.split('T')[0] // YYYY-MM-DD
      const timePart = new Date(o.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
      selectedOrderDate.value = `${datePart} ${timePart}`
    } else {
      selectedOrderDate.value = ''
    }
    
    viewMode.value = 'bill'
    nextTick(() => {
      scrollToBottom()
    })
  }
  </script>
  
  <style scoped>
  input[type=number].no-spinner::-webkit-outer-spin-button,
  input[type=number].no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  input[type=number].no-spinner {
    appearance: textfield;
    -moz-appearance: textfield;
  }
  
  /* TABLE STYLE (same as first component) */
  
  table {
    font-family: 'Segoe UI', sans-serif;
    font-size: 0.75rem;
    color: #1e293b;
  }
  
  th,
  td {
    padding: 8px 10px;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
    white-space: nowrap;
  }
  
  th {
    background: #f1f5f9;
    cursor: default;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 20;
  }
  
  .recipe-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
  }
  
  
  
  .custom-scrollbar::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .custom-scrollbar::-webkit-scrollbar-track {
    background: #f1f5f9;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 4px;
  }
  .custom-scrollbar::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
  
  /* Modal Transitions */
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  
  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }
  
  /* Chrome, Safari, Edge, Opera */
  .no-spinner::-webkit-outer-spin-button,
  .no-spinner::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  
  /* Firefox */
  .no-spinner {
    appearance: textfield;
    -moz-appearance: textfield;
  }
  /* Toast Transitions */
  .toast-enter-active,
  .toast-leave-active {
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  }
  
  .toast-enter-from {
    opacity: 0;
    transform: translateX(100px);
  }
  
  .toast-leave-to {
    opacity: 0;
    transform: scale(0.9);
  }
  
  .spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 0.8s linear infinite;
  }
  
  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  .txn-scan-file-input {
    position: fixed;
    left: -9999px;
    top: 0;
    width: 1px;
    height: 1px;
    opacity: 0;
    overflow: hidden;
  }

  .txn-scan-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid rgba(13, 65, 105, 0.2);
    border-radius: 50%;
    border-top-color: #0d4169;
    animation: spin 0.7s linear infinite;
  }

  .txn-scan-spinner-lg {
    width: 36px;
    height: 36px;
    border: 3px solid rgba(13, 65, 105, 0.15);
    border-radius: 50%;
    border-top-color: #0d4169;
    animation: spin 0.7s linear infinite;
  }
  </style>
  